<template>
  <div class="customer-settings">
    <div class="row">
      <div class="col-md-6">
        <card :title="$t('customerSettings.companyPhoto')">
          <div class="col-lg-4"></div>
          <div class="image-containercustomersettings">
            <image-upload
              class="col-md-6 ml-auto mr-auto"
              :src="'data:image/png;base64,' + customer.logoBytes"
              :base64image="customer.logoBytes"
              :select-text="$t('image.selectImage')"
              @change="onImageChange"
              @upload="onUpload(true)"/>
          </div>
        </card>
      </div>
      <div class="col-md-6">
        <card :title="$t('tools.customQRBanner')">
          <div class="image-containercustomersettings">
            <image-upload
              class="col-md-6 ml-auto mr-auto"
              :src="'data:image/png;base64,' + customer.toolLogoBytes"
              :base64image="customer.toolLogoBytes"
              :select-text="$t('image.selectImage')"
              @change="onImageChange"
              @upload="onUpload(false)"/>
          </div>
        </card>
      </div>
    </div>
    <div class="row">
      <div class="col-md-12">
        <card :title="$t('customerSettings.contactInfo')" class="stacked-form">
          <div class="row">
            <div class="col-md-6">
              <material-input-field
                id="contactEmailInput"
                v-model="contactEmail"
                :name="'contactEmail'"
                variant="static"
                :label="$t('customerSettings.contactEmail')"
                :placeholder="$t('customerSettings.contactEmail')"
              />
            </div>
            <div class="col-md-6">
              <material-input-field
                id="contactPhoneInput"
                v-model="contactPhone"
                :name="'contactPhone'"
                variant="static"
                :label="$t('customerSettings.contactPhone')"
                :placeholder="$t('customerSettings.contactPhone')"
              />
            </div>
          </div>
          <div class="row">
            <div class="col-sm d-flex justify-content-end">
              <material-button class="mt-3" variant="gradient" color="dark" type="button" @click="submitContactInfo">
                {{$t('common.submit')}}
              </material-button>
            </div>
          </div>
        </card>
      </div>
    </div>
    <div class="row">
      <div class="col-md-12">
        <card :title="$t('customerSettings.generalSettings')" class="stacked-form">
          <Form ref="form">
            <div class="row">
              <div class="col-md-6">
                <material-input-field
                  id="defaultPageSizeInput"
                  v-model="defaultPageSize"
                  :name="'defaultPageSize'"
                  variant="static"
                  :label="$t('customerSettings.defaultPageSize')"
                  :placeholder="$t('customerSettings.defaultPageSize')"
                />
              </div>
              <div class="col-md-6">
                <el-tooltip :content="$t('customerSettings.disableCarsTooltip')" placement="right" popper-class="cs-tooltip">
                  <material-checkbox v-model="disableCars">
                    {{$t('customerSettings.disableCars')}}
                  </material-checkbox>
                </el-tooltip>
                <el-tooltip :content="$t('customerSettings.askForToolImageOnReturnForToolReservationsTooltip')" placement="right" popper-class="cs-tooltip">
                  <material-checkbox v-model="askForToolImageOnReturnForToolReservations">
                    {{$t('customerSettings.askForToolImageOnReturnForToolReservations')}}
                  </material-checkbox>
                </el-tooltip>
                <div v-if="askForToolImageOnReturnForToolReservations" class="mt-2 mb-2" style="max-width:240px">
                  <label class="form-label text-sm">{{ $t('customerSettings.askForToolImageOnReturnForToolReservationsAfterDays') }}</label>
                  <input
                    v-model.number="askForToolImageOnReturnForToolReservationsAfterDays"
                    type="number"
                    min="1"
                    step="1"
                    class="form-control form-control-sm"
                    @blur="clampAskForToolImageDays"
                  />
                </div>
                <el-tooltip :content="$t('customerSettings.askForToolImageOnReturnForExternalToolReservationsTooltip')" placement="right" popper-class="cs-tooltip">
                  <material-checkbox v-model="askForToolImageOnReturnForExternalToolReservations">
                    {{$t('customerSettings.askForToolImageOnReturnForExternalToolReservations')}}
                  </material-checkbox>
                </el-tooltip>
                <el-tooltip :content="$t('customerSettings.allowToolReservaAndUnreserveWithourQRScanTooltip')" placement="right" popper-class="cs-tooltip">
                  <material-checkbox v-model="allowToolReservaAndUnreserveWithourQRScan">
                    {{$t('customerSettings.allowToolReservaAndUnreserveWithourQRScan')}}
                  </material-checkbox>
                </el-tooltip>
                <el-tooltip :content="$t('customerSettings.allowAllUsersToReturnTooltip')" placement="right" popper-class="cs-tooltip">
                  <material-checkbox v-model="allowAllUsersToReturn">
                    {{$t('customerSettings.allowAllUsersToReturn')}}
                  </material-checkbox>
                </el-tooltip>
                <el-tooltip :content="$t('customerSettings.requireQRScanForLoanRentReturnsTooltip')" placement="right" popper-class="cs-tooltip">
                  <material-checkbox v-model="requireQRScanForLoanRentReturns">
                    {{$t('customerSettings.requireQRScanForLoanRentReturns')}}
                  </material-checkbox>
                </el-tooltip>
              </div>
            </div>
            <div class="row">
              <div class="col-sm d-flex justify-content-end">
                <material-button class="mt-3" variant="gradient" color="dark" type="button" @click="submitGeneralSettings">
                  {{$t('common.submit')}}
                </material-button>
              </div>
            </div>
          </Form>
        </card>
      </div>
    </div>
    <div v-if="erp !== '' && erp != 'Test'" class="row">
      <div class="col-md-12">
        <card :title="$t('customerSettings.erpSettings')" :custom-method-image="getERPImage">
          <Form ref="erpForm">
            <div class="row">
              <div class="col-md-6">
                <material-input-field v-if="erp === 'DK' || erp === 'DKProjectRequests' || erp === 'DKFinnur' || erp === 'DKWithProjectPhases'" id="DKApiKeyInput" v-model="DKApiKey" type="password" :name="'DKApiKey'" :label="$t('customerSettings.DKApiKey')" :placeholder="$t('customerSettings.DKApiKey')" variant="static" />
                <material-input-field v-if="erp === 'DK' || erp === 'DKProjectRequests' || erp === 'DKWithProjectPhases'" id="DKItemCodeInput" v-model="DKItemCode" :name="'DKItemCode'" :label="$t('customerSettings.DKItemCode')" :placeholder="$t('customerSettings.DKItemCode')" variant="static" />
                <material-input-field v-if="erp === 'Tímon'" id="timonUsernameInput" v-model="timonUsername" :name="'timonUsername'" :label="$t('customerSettings.timonUsername')" :placeholder="$t('customerSettings.timonUsername')" variant="static" />
                <material-input-field v-if="erp === 'Tímon'" id="timonPasswordInput" v-model="timonPassword" type="password" :name="'timonPassword'" :label="$t('customerSettings.timonPassword')" :placeholder="$t('customerSettings.timonPassword')" variant="static" />
                <material-input-field v-if="erp === 'Stólpi'" id="stolpiUsernameInput" v-model="stolpiUsername" :name="'stolpiUsername'" :label="$t('customerSettings.stolpiUsername')" :placeholder="$t('customerSettings.stolpiUsername')" variant="static" />
                <material-input-field v-if="erp === 'BusinessCentralCustomers' || erp === 'BusinessCentralEndCustomers'" id="BCTenantIdInput" v-model="BCTenantId" :name="'BCTenantId'" label="TenantId" placeholder="TenantId" variant="static" />
                <material-input-field v-if="erp === 'BusinessCentralCustomers' || erp === 'BusinessCentralEndCustomers'" id="BCClientIdInput" v-model="BCClientId" type="password" :name="'BCClientId'" label="ClientId" placeholder="ClientId" variant="static" />
                <material-input-field v-if="erp === 'BusinessCentralCustomers' || erp === 'BusinessCentralEndCustomers'" id="BCClientSecretInput" v-model="BCClientSecret" type="password" :name="'BCClientSecret'" label="Client Secret" placeholder="Client Secret" variant="static" />
                <material-input-field v-if="erp === 'BusinessCentralCustomers' || erp === 'BusinessCentralEndCustomers'" id="BCLocationIdInput" v-model="BCLocationId" :name="'BCLocationId'" label="LocationId" placeholder="LocationId" variant="static" />
                <material-input-field v-if="erp === 'ReglaIs'" id="reglaUsernameInput" v-model="reglaUsername" :name="'reglaUsername'" :label="$t('customerSettings.reglaUsername')" :placeholder="$t('customerSettings.reglaUsername')" variant="static" />
                <material-input-field v-if="erp === 'ReglaIs'" id="reglaPasswordInput" v-model="reglaPassword" type="password" :name="'reglaPassword'" :label="$t('customerSettings.reglaPassword')" :placeholder="$t('customerSettings.reglaPassword')" variant="static" />
                <material-input-field v-if="erp === 'Verklag'" id="verklagClientIdInput" v-model="verklagClientId" :name="'verklagClientId'" label="Client ID" placeholder="Client ID" variant="static" />
                <material-input-field v-if="erp === 'Verklag'" id="verklagClientSecretInput" v-model="verklagClientSecret" type="password" :name="'verklagClientSecret'" label="Client Secret" placeholder="Client Secret" variant="static" />
                <material-input-field v-if="erp === 'Unnur'" id="unnurClientIdInput" v-model="unnurClientId" :name="'unnurClientId'" label="Client ID" placeholder="Client ID" variant="static" />
                <material-input-field v-if="erp === 'Unnur'" id="unnurClientSecretInput" v-model="unnurClientSecret" type="password" :name="'unnurClientSecret'" label="Client Secret" placeholder="Client Secret" variant="static" />
              </div>
              <div class="col-md-6">
                <material-input-field v-if="erp === 'DK' || erp === 'DKProjectRequests'" id="DKWebhookSecretInput" v-model="DKWebhookSecret" type="password" :name="'DKWebhookSecret'" :label="$t('customerSettings.DKWebhookSecret')" :placeholder="$t('customerSettings.DKWebhookSecret')" variant="static" />
                <material-input-field v-if="erp === 'Tímon'" id="timonUrlInput" v-model="timonUrl" :name="'timonUrl'" :label="$t('customerSettings.timonUrl')" :placeholder="$t('customerSettings.timonUrl')" variant="static" />
                <material-input-field v-if="erp === 'Stólpi'" id="stolpiPasswordInput" v-model="stolpiPassword" type="password" :name="'stolpiPassword'" :label="$t('customerSettings.stolpiPassword')" :placeholder="$t('customerSettings.stolpiPassword')" variant="static" />
                <material-input-field v-if="erp === 'BusinessCentralCustomers' || erp === 'BusinessCentralEndCustomers'" id="BCScopeInput" v-model="BCScope" :name="'BCScope'" label="Client Scope" placeholder="Client Scope" variant="static" />
                <material-input-field v-if="erp === 'BusinessCentralCustomers' || erp === 'BusinessCentralEndCustomers'" id="BCTokenUrlInput" v-model="BCTokenUrl" :name="'BCTokenUrl'" label="Token URL" placeholder="Token URL" variant="static" />
                <material-input-field v-if="erp === 'BusinessCentralCustomers' || erp === 'BusinessCentralEndCustomers'" id="BCCompanyIdInput" v-model="BCCompanyId" :name="'BCCompanyId'" label="CompanyId" placeholder="CompanyId" variant="static" />
                <material-input-field v-if="erp === 'BusinessCentralCustomers' || erp === 'BusinessCentralEndCustomers'" id="BCEnvironmentInput" v-model="BCEnvironment" :name="'BCEnvironment'" label="Environment" placeholder="Environment" variant="static" />
                <material-input-field v-if="erp === 'Unnur'" id="unnurUrlInput" v-model="unnurUrl" :name="'unnurUrl'" label="URL" placeholder="URL" variant="static" />
              </div>
              <div v-if="erpSupportsTimeRegSync && enableTimeRegistrationSyncToERP" class="col-12 mt-3">
                <el-tooltip :content="$t('customerSettings.enableAutomaticERPSyncForTimeRegistrationEntriesTooltip')" placement="right" popper-class="cs-tooltip">
                  <material-checkbox v-model="enableAutomaticERPSyncForTimeRegistrationEntries">{{ $t('customerSettings.enableAutomaticERPSyncForTimeRegistrationEntries') }}</material-checkbox>
                </el-tooltip>
              </div>
              <template v-if="(erp === 'DK' || erp === 'DKProjectRequests' || erp === 'DKWithProjectPhases') && enableTimeRegistrationSyncToERP">
                <div class="col-12 mt-3">
                  <h6 class="text-sm">{{ $t('customerSettings.dkTimeRegSyncHeading') }}</h6>
                  <small class="text-secondary d-block mb-2">{{ $t('customerSettings.dkTimeRegSyncHint') }}</small>
                </div>
                <div class="col-md-7">
                  <div v-for="t in dkTimeRegAbsenceTypes" :key="t" class="mb-3">
                    <label class="form-label text-sm d-block mb-1">{{ $t('customerSettings.dkTimeReg' + t + 'Mapping') }}</label>
                    <div class="d-flex gap-2 flex-wrap">
                      <el-select
                        v-model="dkTimeRegMappings[t].projectKey"
                        filterable
                        remote
                        clearable
                        :remote-method="dkTimeRegSearchProjects"
                        :loading="dkTimeRegProjectsLoading"
                        :placeholder="$t('customerSettings.dkTimeRegSelectProject')"
                        style="min-width:280px"
                        @change="dkTimeRegProjectChanged(t)"
                        @focus="dkTimeRegSearchProjects('')"
                      >
                        <el-option v-for="p in dkTimeRegOptionsFor(t)" :key="p.key" :value="p.key" :label="(p.key ? '[' + p.key + '] ' : '') + p.name" />
                      </el-select>
                      <el-select
                        v-if="dkTimeRegMappings[t].phases.length"
                        v-model="dkTimeRegMappings[t].phaseKey"
                        clearable
                        :placeholder="$t('customerSettings.dkTimeRegSelectPhase')"
                        style="min-width:220px"
                      >
                        <el-option v-for="ph in dkTimeRegMappings[t].phases" :key="ph.key" :value="ph.key" :label="'[' + ph.key + '] ' + ph.name" />
                      </el-select>
                    </div>
                  </div>
                </div>
                <div class="col-md-5">
                  <div class="mb-3" style="max-width:260px">
                    <label class="form-label text-sm">{{ $t('customerSettings.dkTimeRegAfterHoursTarget') }}</label>
                    <select v-model="DKTimeRegAfterHoursTarget" class="form-select form-select-sm">
                      <option value="OverTime">{{ $t('customerSettings.dkTimeRegOverTime') }}</option>
                      <option value="DayTime">{{ $t('customerSettings.dkTimeRegDayTime') }}</option>
                    </select>
                  </div>
                  <div class="mb-3" style="max-width:260px">
                    <label class="form-label text-sm">{{ $t('customerSettings.dkTimeRegRedDayHoursTarget') }}</label>
                    <select v-model="DKTimeRegRedDayHoursTarget" class="form-select form-select-sm">
                      <option value="OverTime">{{ $t('customerSettings.dkTimeRegOverTime') }}</option>
                      <option value="DayTime">{{ $t('customerSettings.dkTimeRegDayTime') }}</option>
                    </select>
                  </div>
                  <material-checkbox v-model="DKTimeRegWorkEntriesBillable">{{ $t('customerSettings.dkTimeRegWorkEntriesBillable') }}</material-checkbox>
                </div>
              </template>
              <!-- One item fetch shared by the time registration and cost sync sections below -->
              <div v-if="erp === 'BusinessCentralEndCustomers' && (enableTimeRegistrationSyncToERP || enableERPCostSync)" class="col-12 mt-3">
                <material-button color="dark" size="sm" :disabled="bcItemsLoading" @click.prevent="loadBcItems">
                  {{ bcItemsLoading ? $t('customerSettings.bcTimeRegLoadingItems') : $t('customerSettings.bcTimeRegLoadItems') }}
                </material-button>
              </div>
              <template v-if="erp === 'BusinessCentralEndCustomers' && enableTimeRegistrationSyncToERP">
                <div class="col-12 mt-3">
                  <h6 class="text-sm">{{ $t('customerSettings.bcTimeRegSyncHeading') }}</h6>
                  <small class="text-secondary d-block mb-2">{{ $t('customerSettings.bcTimeRegSyncHint') }}</small>
                </div>
                <div class="col-md-7">
                  <div v-if="bcTimeRegEditing" class="border rounded p-2" style="max-height:320px;overflow-y:auto">
                    <div v-for="it in bcItems" :key="it.number" class="form-check">
                      <input :id="'bcItem-' + it.number" v-model="bcSelectedItemNumbers" class="form-check-input" type="checkbox" :value="it.number">
                      <label class="form-check-label text-sm" :for="'bcItem-' + it.number">
                        [{{ it.number }}] {{ it.displayName }}{{ it.baseUnitOfMeasureCode ? ' (' + it.baseUnitOfMeasureCode + ')' : '' }}{{ it.blocked ? ' ⛔' : '' }}
                      </label>
                    </div>
                  </div>
                  <div v-else-if="bcTimeRegItems.length" class="border rounded p-2" style="max-height:320px;overflow-y:auto">
                    <div class="text-xs text-uppercase text-secondary fw-bold mb-1">
                      {{ $t('customerSettings.bcTimeRegSelectedItems') }} ({{ bcTimeRegItems.length }})
                    </div>
                    <div
                      v-for="(it, idx) in bcTimeRegItems"
                      :key="it.number"
                      class="d-flex align-items-center gap-2 py-1 text-sm"
                      :class="{ 'border-bottom': idx < bcTimeRegItems.length - 1 }"
                    >
                      <span class="text-secondary" style="min-width:3.5rem">{{ it.number }}</span>
                      <span class="flex-grow-1">{{ it.displayName }}</span>
                      <span v-if="it.number === BCTimeRegDefaultItem" class="badge bg-dark">{{ $t('customerSettings.bcTimeRegDefaultItem') }}</span>
                      <span v-if="it.number === BCTimeRegOvertimeItem" class="badge bg-warning text-dark">{{ $t('customerSettings.bcTimeRegOvertimeItem') }}</span>
                    </div>
                  </div>
                </div>
                <div class="col-md-5">
                  <div class="mb-3" style="max-width:300px">
                    <label class="form-label text-sm">{{ $t('customerSettings.bcTimeRegDefaultItem') }}</label>
                    <select v-model="BCTimeRegDefaultItem" class="form-select form-select-sm">
                      <option value="">{{ $t('customerSettings.bcTimeRegNoItem') }}</option>
                      <option v-for="it in bcSelectableItems" :key="it.number" :value="it.number">[{{ it.number }}] {{ it.displayName }}</option>
                    </select>
                  </div>
                  <div class="mb-3" style="max-width:300px">
                    <label class="form-label text-sm">{{ $t('customerSettings.bcTimeRegOvertimeItem') }}</label>
                    <select v-model="BCTimeRegOvertimeItem" class="form-select form-select-sm">
                      <option value="">{{ $t('customerSettings.bcTimeRegNoItem') }}</option>
                      <option v-for="it in bcSelectableItems" :key="it.number" :value="it.number">[{{ it.number }}] {{ it.displayName }}</option>
                    </select>
                  </div>
                  <div class="mb-3" style="max-width:300px">
                    <label class="form-label text-sm">{{ $t('customerSettings.dkTimeRegAfterHoursTarget') }}</label>
                    <select v-model="BCTimeRegAfterHoursTarget" class="form-select form-select-sm">
                      <option value="OverTime">{{ $t('customerSettings.dkTimeRegOverTime') }}</option>
                      <option value="DayTime">{{ $t('customerSettings.dkTimeRegDayTime') }}</option>
                    </select>
                  </div>
                  <div class="mb-3" style="max-width:300px">
                    <label class="form-label text-sm">{{ $t('customerSettings.dkTimeRegRedDayHoursTarget') }}</label>
                    <select v-model="BCTimeRegRedDayHoursTarget" class="form-select form-select-sm">
                      <option value="OverTime">{{ $t('customerSettings.dkTimeRegOverTime') }}</option>
                      <option value="DayTime">{{ $t('customerSettings.dkTimeRegDayTime') }}</option>
                    </select>
                  </div>
                </div>
              </template>
              <template v-if="erp === 'BusinessCentralEndCustomers' && enableERPCostSync">
                <div class="col-12 mt-3">
                  <h6 class="text-sm">{{ $t('customerSettings.bcCostSyncHeading') }}</h6>
                  <small class="text-secondary d-block mb-2">{{ $t('customerSettings.bcCostSyncHint') }}</small>
                </div>
                <div class="col-12">
                  <div class="mb-3" style="max-width:300px">
                    <label class="form-label text-sm">{{ $t('customerSettings.bcCostItem') }}</label>
                    <select v-model="BCCostItem" class="form-select form-select-sm">
                      <option value="">{{ $t('customerSettings.bcTimeRegNoItem') }}</option>
                      <option v-for="it in bcCostItemOptions" :key="it.number" :value="it.number">[{{ it.number }}] {{ it.displayName }}</option>
                    </select>
                  </div>
                </div>
              </template>
              <div class="col-sm d-flex justify-content-end">
                <material-button class="mt-3" color="dark" @click="submitERPSettings">
                  {{$t('common.submit')}}
                </material-button>
              </div>
            </div>
          </Form>
        </card>
      </div>
    </div>

    <div v-if="enableProjectCreation" class="row">
      <div class="col-md-12">
        <card :title="$t('customerSettings.projectCreationSettings')">
          <Form ref="publisherForm">
            <div class="row">
              <div class="col-md-6">
                <label class="form-label text-sm">{{ $t('customerSettings.projectDataPublisher') }}</label>
                <select v-model="projectDataPublisher" class="form-control form-control-sm">
                  <option value="">{{ $t('customerSettings.projectDataPublisherNone') }}</option>
                  <option value="Husasmidjan">Húsasmiðjan</option>
                </select>
              </div>
            </div>
            <div v-if="projectDataPublisher === 'Husasmidjan'" class="row">
              <div class="col-md-6">
                <material-input-field id="husasmidjanUsernameInput" v-model="husasmidjanUsername" :name="'husasmidjanUsername'" :label="$t('customerSettings.husasmidjanUsername')" :placeholder="$t('customerSettings.husasmidjanUsername')" variant="static" />
              </div>
              <div class="col-md-6">
                <material-input-field id="husasmidjanPasswordInput" v-model="husasmidjanPassword" type="password" :name="'husasmidjanPassword'" :label="$t('customerSettings.husasmidjanPassword')" :placeholder="$t('customerSettings.husasmidjanPassword')" variant="static" />
              </div>
            </div>
            <div class="row">
              <div class="col-sm d-flex justify-content-end">
                <material-button class="mt-3" color="dark" @click="submitProjectDataPublisherSettings">
                  {{$t('common.submit')}}
                </material-button>
              </div>
            </div>
          </Form>
        </card>
      </div>
    </div>

    <div v-if="enablePreCreatedProjectAssignments || enableDayProjectAssignments" class="row">
      <div class="col-md-12">
        <card :title="$t('customerSettings.customNamesSettings')">
          <!-- <Form ref="calendarForm"> -->
            <div class="row">
              <div class="col-md-6">
                <material-input-field v-if="enablePreCreatedProjectAssignments" id="preCreatedDayProjectAssignmentsCustomNameInput" v-model="preCreatedDayProjectAssignmentsCustomName" :name="'preCreatedDayProjectAssignmentsCustomName'" :label="$t('customerSettings.preCreatedDayProjectAssignmentsCustomName')" :placeholder="$t('customerSettings.preCreatedDayProjectAssignmentsCustomName')" variant="static" />
              </div>
              <div class="col-md-6">
                <material-input-field v-if="enableDayProjectAssignments" id="dayProjectAssignmentsCustomNameInput" v-model="dayProjectAssignmentsCustomName" :name="'dayProjectAssignmentsCustomName'" :label="$t('customerSettings.dayProjectAssignmentsCustomName')" :placeholder="$t('customerSettings.dayProjectAssignmentsCustomName')" variant="static" />
              </div>
              <div class="col-sm d-flex justify-content-end">
                <material-button class="mt-3" color="dark" @click="submitCalendarSettings">
                  {{$t('common.submit')}}
                </material-button>
              </div>
            </div>
          <!-- </Form> -->
        </card>
      </div>
    </div>

    <div v-if="userRole === 'SuperAdmin'" class="row">
      <div class="col-md-12">
        <card :title="$t('customerSettings.superAdminSettings')">
          <div class="row mb-2">
            <div class="col-12">
              <button
                type="button"
                class="ts-multi-pills__toggle-all"
                @click="toggleAllSuperAdminTabs"
              >
                <i class="material-icons">{{ allSuperAdminTabsVisible ? 'unfold_less' : 'unfold_more' }}</i>
                <span class="ms-1">{{ allSuperAdminTabsVisible ? $t('common.collapseAll') : $t('common.expandAll') }}</span>
              </button>
            </div>
          </div>
          <div class="row mb-3">
            <div class="col-12">
              <div class="ts-multi-pills">
                <button
                  v-for="tab in superAdminTabs"
                  :key="tab.key"
                  type="button"
                  class="ts-multi-pills__item"
                  :class="{ 'ts-multi-pills__item--active': isTabVisible(tab.key) }"
                  @click="toggleSuperAdminTab(tab.key)"
                >
                  <i class="material-icons ts-multi-pills__icon">{{ tab.icon }}</i>
                  <span class="ms-1">{{ tab.label }}</span>
                </button>
              </div>
            </div>
          </div>

          <div class="ts-multi-pills__grid">
            <div v-show="isTabVisible('projects')" class="ts-multi-pills__section">
              <h6 class="ts-multi-pills__heading">
                <i class="material-icons">work</i>
                <span>{{ $t('customerSettings.projectsSection') }}</span>
              </h6>
              <el-tooltip :content="$t('customerSettings.enableProjectCreationTooltip')" placement="right" popper-class="cs-tooltip">
                <material-checkbox v-model="enableProjectCreation">{{$t('customerSettings.enableProjectCreation')}}</material-checkbox>
              </el-tooltip>
              <el-tooltip :content="$t('customerSettings.enableProjectTypesTooltip')" placement="right" popper-class="cs-tooltip">
                <material-checkbox v-model="enableProjectTypes">{{$t('customerSettings.enableProjectTypes')}}</material-checkbox>
              </el-tooltip>
              <el-tooltip :content="$t('customerSettings.enableProjectAssignmentTypesTooltip')" placement="right" popper-class="cs-tooltip">
                <material-checkbox v-model="enableProjectAssignmentTypes">{{$t('customerSettings.enableProjectAssignmentTypes')}}</material-checkbox>
              </el-tooltip>
              <el-tooltip :content="$t('customerSettings.enableProjectPricesTooltip')" placement="right" popper-class="cs-tooltip">
                <material-checkbox v-model="enableProjectPrices">{{$t('customerSettings.enableProjectPrices')}}</material-checkbox>
              </el-tooltip>
              <el-tooltip :content="$t('customerSettings.enableManualProjectPriceSettingTooltip')" placement="right" popper-class="cs-tooltip">
                <material-checkbox v-model="enableManualProjectPriceSetting">{{$t('customerSettings.enableManualProjectPriceSetting')}}</material-checkbox>
              </el-tooltip>
              <el-tooltip :content="$t('customerSettings.enableFutureReservationProjectAssignmentsTooltip')" placement="right" popper-class="cs-tooltip">
                <material-checkbox v-model="enableFutureReservationProjectAssignments">{{$t('customerSettings.enableFutureReservationProjectAssignments')}}</material-checkbox>
              </el-tooltip>
              <el-tooltip :content="$t('customerSettings.enablePreCreatedProjectAssignmentsTooltip')" placement="right" popper-class="cs-tooltip">
                <material-checkbox v-model="enablePreCreatedProjectAssignments">{{$t('customerSettings.enablePreCreatedProjectAssignments')}}</material-checkbox>
              </el-tooltip>
              <el-tooltip :content="$t('customerSettings.enableDayProjectAssignmentsTooltip')" placement="right" popper-class="cs-tooltip">
                <material-checkbox v-model="enableDayProjectAssignments">{{$t('customerSettings.enableDayProjectAssignments')}}</material-checkbox>
              </el-tooltip>
              <el-tooltip :content="$t('customerSettings.enableProjectPhasesTooltip')" placement="right" popper-class="cs-tooltip">
                <material-checkbox v-model="enableProjectPhases">{{$t('customerSettings.enableProjectPhases')}}</material-checkbox>
              </el-tooltip>
            </div>

            <div v-show="isTabVisible('endCustomers')" class="ts-multi-pills__section">
              <h6 class="ts-multi-pills__heading">
                <i class="material-icons">people</i>
                <span>{{ $t('customerSettings.endCustomersSection') }}</span>
              </h6>
              <el-tooltip :content="$t('customerSettings.enableEndCustomersTooltip')" placement="right" popper-class="cs-tooltip">
                <material-checkbox v-model="enableEndCustomers">{{$t('customerSettings.enableEndCustomers')}}</material-checkbox>
              </el-tooltip>
              <el-tooltip :content="$t('customerSettings.forceEndCustomerSelectionOnProjectCreationTooltip')" placement="right" popper-class="cs-tooltip">
                <material-checkbox v-model="forceEndCustomerSelectionOnProjectCreation">{{$t('customerSettings.forceEndCustomerSelectionOnProjectCreation')}}</material-checkbox>
              </el-tooltip>
            </div>

            <div v-show="isTabVisible('planner')" class="ts-multi-pills__section">
              <h6 class="ts-multi-pills__heading">
                <i class="material-icons">calendar_month</i>
                <span>{{ $t('customerSettings.plannerSection') }}</span>
              </h6>
              <el-tooltip :content="$t('customerSettings.enablePlannerTooltip')" placement="right" popper-class="cs-tooltip">
                <material-checkbox v-model="enablePlanner">{{$t('customerSettings.enablePlanner')}}</material-checkbox>
              </el-tooltip>
              <div class="mb-2">
                <label class="form-label small mb-1">{{ $t('customerSettings.plannerDefaultView') }}</label>
                <el-tooltip :content="$t('customerSettings.plannerDefaultViewTooltip')" placement="right" popper-class="cs-tooltip">
                  <select v-model="plannerDefaultView" class="form-select form-select-sm" style="max-width:200px;">
                    <option value="Day">{{ $t('golf.dayView') }}</option>
                    <option value="Week">{{ $t('golf.weekView') }}</option>
                    <option value="Month">{{ $t('golf.monthView') }}</option>
                  </select>
                </el-tooltip>
              </div>
              <el-tooltip :content="$t('customerSettings.onlyShowUsersWithAssignmentsInPlannerTooltip')" placement="right" popper-class="cs-tooltip">
                <material-checkbox v-model="onlyShowUsersWithAssignmentsInPlanner">{{$t('customerSettings.onlyShowUsersWithAssignmentsInPlanner')}}</material-checkbox>
              </el-tooltip>
              <el-tooltip :content="$t('customerSettings.enableAssignmentCreationInPlannerMonthViewTooltip')" placement="right" popper-class="cs-tooltip">
                <material-checkbox v-model="enableAssignmentCreationInPlannerMonthView">{{$t('customerSettings.enableAssignmentCreationInPlannerMonthView')}}</material-checkbox>
              </el-tooltip>
              <el-tooltip :content="$t('customerSettings.enableProjectAssignmentMultiplierInPlannerTooltip')" placement="right" popper-class="cs-tooltip">
                <material-checkbox v-model="enableProjectAssignmentMultiplierInPlanner">{{$t('customerSettings.enableProjectAssignmentMultiplierInPlanner')}}</material-checkbox>
              </el-tooltip>
              <el-tooltip :content="$t('customerSettings.disableRoutinesInPlannerTooltip')" placement="right" popper-class="cs-tooltip">
                <material-checkbox v-model="disableRoutinesInPlanner">{{$t('customerSettings.disableRoutinesInPlanner')}}</material-checkbox>
              </el-tooltip>
              <el-tooltip :content="$t('customerSettings.disableTaskCreationInPlannerTooltip')" placement="right" popper-class="cs-tooltip">
                <material-checkbox v-model="disableTaskCreationInPlanner">{{$t('customerSettings.disableTaskCreationInPlanner')}}</material-checkbox>
              </el-tooltip>
              <el-tooltip :content="$t('customerSettings.disableToolsInPlannerTooltip')" placement="right" popper-class="cs-tooltip">
                <material-checkbox v-model="disableToolsInPlanner">{{$t('customerSettings.disableToolsInPlanner')}}</material-checkbox>
              </el-tooltip>
              <el-tooltip :content="$t('customerSettings.useAssignmentStatusColorsInPlannerTooltip')" placement="right" popper-class="cs-tooltip">
                <material-checkbox v-model="useAssignmentStatusColorsInPlanner">{{$t('customerSettings.useAssignmentStatusColorsInPlanner')}}</material-checkbox>
              </el-tooltip>
              <el-tooltip :content="$t('customerSettings.usePreCreatedAssignmentsFilteringInPlannerTooltip')" placement="right" popper-class="cs-tooltip">
                <material-checkbox v-model="usePreCreatedAssignmentsFilteringInPlanner">{{$t('customerSettings.usePreCreatedAssignmentsFilteringInPlanner')}}</material-checkbox>
              </el-tooltip>
              <el-tooltip :content="$t('customerSettings.onlyShowPreCreatedAssignmentsInPlannerTooltip')" placement="right" popper-class="cs-tooltip">
                <material-checkbox v-model="onlyShowPreCreatedAssignmentsInPlanner">{{$t('customerSettings.onlyShowPreCreatedAssignmentsInPlanner')}}</material-checkbox>
              </el-tooltip>
            </div>

            <div v-show="isTabVisible('tools')" class="ts-multi-pills__section">
              <h6 class="ts-multi-pills__heading">
                <i class="material-icons">build</i>
                <span>{{ $t('customerSettings.toolsSection') }}</span>
              </h6>
              <el-tooltip :content="$t('customerSettings.enableCustomQRBannerTooltip')" placement="right" popper-class="cs-tooltip">
                <material-checkbox v-model="enableCustomQRBanner">{{$t('customerSettings.enableCustomQRBanner')}}</material-checkbox>
              </el-tooltip>
              <el-tooltip :content="$t('customerSettings.enableToolPriceTypesTooltip')" placement="right" popper-class="cs-tooltip">
                <material-checkbox v-model="enableToolPriceTypes">{{$t('customerSettings.enableToolPriceTypes')}}</material-checkbox>
              </el-tooltip>
              <el-tooltip :content="$t('customerSettings.allowLocationFilteringForToolsTooltip')" placement="right" popper-class="cs-tooltip">
                <material-checkbox v-model="allowLocationFilteringForTools">{{$t('customerSettings.allowLocationFilteringForTools')}}</material-checkbox>
              </el-tooltip>
              <el-tooltip :content="$t('customerSettings.allowAssigningToolToOtherUserTooltip')" placement="right" popper-class="cs-tooltip">
                <material-checkbox v-model="allowAssigningToolToOtherUser">{{$t('customerSettings.allowAssigningToolToOtherUser')}}</material-checkbox>
              </el-tooltip>
              <el-tooltip :content="$t('customerSettings.allowUsersToMarkBrokenTooltip')" placement="right" popper-class="cs-tooltip">
                <material-checkbox v-model="allowUsersToMarkBroken">{{$t('customerSettings.allowUsersToMarkBroken')}}</material-checkbox>
              </el-tooltip>
              <el-tooltip :content="$t('customerSettings.requireRepairNotesTooltip')" placement="right" popper-class="cs-tooltip">
                <material-checkbox v-model="requireRepairNotes">{{$t('customerSettings.requireRepairNotes')}}</material-checkbox>
              </el-tooltip>
              <el-tooltip :content="$t('customerSettings.enableGPSTooltip')" placement="right" popper-class="cs-tooltip">
                <material-checkbox v-model="enableGPS">{{$t('customerSettings.enableGPS')}}</material-checkbox>
              </el-tooltip>
              <el-tooltip :content="$t('customerSettings.enableToolRemindersTooltip')" placement="right" popper-class="cs-tooltip">
                <material-checkbox v-model="enableToolReminders">{{$t('customerSettings.enableToolReminders')}}</material-checkbox>
              </el-tooltip>
            </div>

            <div v-show="isTabVisible('cars')" class="ts-multi-pills__section">
              <h6 class="ts-multi-pills__heading">
                <i class="material-icons">directions_car</i>
                <span>{{ $t('customerSettings.carsSection') }}</span>
              </h6>
              <el-tooltip :content="$t('customerSettings.enableQRScanForCarToolAssignmentTooltip')" placement="right" popper-class="cs-tooltip">
                <material-checkbox v-model="enableQRScanForCarToolAssignment">{{$t('customerSettings.enableQRScanForCarToolAssignment')}}</material-checkbox>
              </el-tooltip>
              <el-tooltip :content="$t('customerSettings.allowUsersToAddRemoveCarToolsTooltip')" placement="right" popper-class="cs-tooltip">
                <material-checkbox v-model="allowUsersToAddRemoveCarTools">{{$t('customerSettings.allowUsersToAddRemoveCarTools')}}</material-checkbox>
              </el-tooltip>
              <el-tooltip :content="$t('customerSettings.allowAssignedUsersToEditVehiclesTooltip')" placement="right" popper-class="cs-tooltip">
                <material-checkbox v-model="allowAssignedUsersToEditVehicles">{{$t('customerSettings.allowAssignedUsersToEditVehicles')}}</material-checkbox>
              </el-tooltip>
            </div>

            <div v-show="isTabVisible('loansRentals')" class="ts-multi-pills__section">
              <h6 class="ts-multi-pills__heading">
                <i class="material-icons">swap_horiz</i>
                <span>{{ $t('customerSettings.loansRentalsSection') }}</span>
              </h6>
              <el-tooltip :content="$t('customerSettings.loanRentCustomerTooltip')" placement="right" popper-class="cs-tooltip">
                <material-checkbox v-model="loanRentCustomer">{{$t('customerSettings.loanRentCustomer')}}</material-checkbox>
              </el-tooltip>
              <el-tooltip :content="$t('customerSettings.enableMultiRentalsTooltip')" placement="right" popper-class="cs-tooltip">
                <material-checkbox v-model="enableMultiRentals">{{$t('customerSettings.enableMultiRentals')}}</material-checkbox>
              </el-tooltip>
              <el-tooltip :content="$t('customerSettings.enableRentalsOnlyTooltip')" placement="right" popper-class="cs-tooltip">
                <material-checkbox v-model="enableRentalsOnly">{{$t('customerSettings.enableRentalsOnly')}}</material-checkbox>
              </el-tooltip>
              <el-tooltip :content="$t('customerSettings.forceProjectConnectionOnRentalsTooltip')" placement="right" popper-class="cs-tooltip">
                <material-checkbox v-model="forceProjectConnectionOnRentals">{{$t('customerSettings.forceProjectConnectionOnRentals')}}</material-checkbox>
              </el-tooltip>
            </div>

            <div v-show="isTabVisible('costReporting')" class="ts-multi-pills__section">
              <h6 class="ts-multi-pills__heading">
                <i class="material-icons">request_quote</i>
                <span>{{ $t('customerSettings.costReportingSection') }}</span>
              </h6>
              <el-tooltip :content="$t('customerSettings.enableERPCostSyncTooltip')" placement="right" popper-class="cs-tooltip">
                <material-checkbox v-model="enableERPCostSync">{{$t('customerSettings.enableERPCostSync')}}</material-checkbox>
              </el-tooltip>
              <el-tooltip :content="$t('customerSettings.pickToolsInProjectCostReportTooltip')" placement="right" popper-class="cs-tooltip">
                <material-checkbox v-model="pickToolsInProjectCostReport">{{$t('customerSettings.pickToolsInProjectCostReport')}}</material-checkbox>
              </el-tooltip>
            </div>

            <div v-show="isTabVisible('modules')" class="ts-multi-pills__section">
              <h6 class="ts-multi-pills__heading">
                <i class="material-icons">extension</i>
                <span>{{ $t('customerSettings.modulesSection') }}</span>
              </h6>
              <el-tooltip :content="$t('customerSettings.enableGolfTooltip')" placement="right" popper-class="cs-tooltip">
                <material-checkbox v-model="enableGolf">{{$t('customerSettings.enableGolf')}}</material-checkbox>
              </el-tooltip>
              <el-tooltip :content="$t('customerSettings.enableExcelExportTooltip')" placement="right" popper-class="cs-tooltip">
                <material-checkbox v-model="enableExcelExport">{{$t('customerSettings.enableExcelExport')}}</material-checkbox>
              </el-tooltip>
            </div>

            <div v-show="isTabVisible('users')" class="ts-multi-pills__section">
              <h6 class="ts-multi-pills__heading">
                <i class="material-icons">group</i>
                <span>{{ $t('customerSettings.usersSection') }}</span>
              </h6>
              <el-tooltip :content="$t('customerSettings.enableUserGroupsTooltip')" placement="right" popper-class="cs-tooltip">
                <material-checkbox v-model="enableUserGroups">{{$t('customerSettings.enableUserGroups')}}</material-checkbox>
              </el-tooltip>
            </div>

            <div v-show="isTabVisible('timeRegistration')" class="ts-multi-pills__section">
              <h6 class="ts-multi-pills__heading">
                <i class="material-icons">schedule</i>
                <span>{{ $t('customerSettings.timeRegistrationSection') }}</span>
              </h6>
              <el-tooltip :content="$t('customerSettings.enableTimeRegistrationTooltip')" placement="right" popper-class="cs-tooltip">
                <material-checkbox v-model="enableTimeRegistration">{{ $t('timeRegistration.enableTimeRegistration') }}</material-checkbox>
              </el-tooltip>
              <el-tooltip v-if="enableTimeRegistration" :content="$t('customerSettings.enableTimesheetAdjustmentsTooltip')" placement="right" popper-class="cs-tooltip">
                <material-checkbox v-model="enableTimesheetAdjustments">{{ $t('timeRegistration.enableAdjustedTimes') }}</material-checkbox>
              </el-tooltip>
              <el-tooltip v-if="enableTimeRegistration" :content="$t('customerSettings.allowAdminMoveTimesheetEntryTooltip')" placement="right" popper-class="cs-tooltip">
                <material-checkbox v-model="allowAdminMoveTimesheetEntry">{{ $t('timeRegistration.allowAdminMoveTimesheetEntry') }}</material-checkbox>
              </el-tooltip>
              <el-tooltip v-if="enableTimeRegistration" :content="$t('customerSettings.allowUsersToEditAndDeleteOwnTimesheetEntriesTooltip')" placement="right" popper-class="cs-tooltip">
                <material-checkbox v-model="allowUsersToEditAndDeleteOwnTimesheetEntries">{{ $t('timeRegistration.allowUsersToEditAndDeleteOwnTimesheetEntries') }}</material-checkbox>
              </el-tooltip>
              <!-- Simplified and end-of-day registration are separate modes — only one at a time -->
              <el-tooltip v-if="enableTimeRegistration && !enableEndOfDayTimeRegistration" :content="$t('customerSettings.enableSimplifiedTimeRegistrationTooltip')" placement="right" popper-class="cs-tooltip">
                <material-checkbox v-model="enableSimplifiedTimeRegistration">{{ $t('timeRegistration.enableSimplifiedTimeRegistration') }}</material-checkbox>
              </el-tooltip>
              <el-tooltip v-if="enableTimeRegistration && !enableSimplifiedTimeRegistration" :content="$t('customerSettings.enableEndOfDayTimeRegistrationTooltip')" placement="right" popper-class="cs-tooltip">
                <material-checkbox v-model="enableEndOfDayTimeRegistration">{{ $t('timeRegistration.enableEndOfDayTimeRegistration') }}</material-checkbox>
              </el-tooltip>
              <el-tooltip v-if="enableTimeRegistration && enableEndOfDayTimeRegistration" :content="$t('customerSettings.enableReferenceInTimeRegistrationTooltip')" placement="right" popper-class="cs-tooltip">
                <material-checkbox v-model="enableReferenceInTimeRegistration">{{ $t('timeRegistration.enableReferenceInTimeRegistration') }}</material-checkbox>
              </el-tooltip>
              <el-tooltip v-if="enableTimeRegistration" :content="$t('customerSettings.enableUnfinishedTimeRegistrationDaysInOverviewTooltip')" placement="right" popper-class="cs-tooltip">
                <material-checkbox v-model="enableUnfinishedTimeRegistrationDaysInOverview">{{ $t('timeRegistration.enableUnfinishedTimeRegistrationDaysInOverview') }}</material-checkbox>
              </el-tooltip>
              <el-tooltip v-if="enableTimeRegistration" :content="$t('customerSettings.enableCustomOvertimeScheduleTooltip')" placement="right" popper-class="cs-tooltip">
                <material-checkbox v-model="enableCustomOvertimeSchedule">{{ $t('timeRegistration.enableCustomOvertimeSchedule') }}</material-checkbox>
              </el-tooltip>
              <el-tooltip v-if="enableTimeRegistration" :content="$t('customerSettings.requireGpsClockInTooltip')" placement="right" popper-class="cs-tooltip">
                <material-checkbox v-model="requireGpsClockIn">{{ $t('timeRegistration.requireGpsClockIn') }}</material-checkbox>
              </el-tooltip>
              <el-tooltip v-if="enableTimeRegistration" :content="$t('customerSettings.enableCommentsOnTimesheetEntriesTooltip')" placement="right" popper-class="cs-tooltip">
                <material-checkbox v-model="enableCommentsOnTimesheetEntries">{{ $t('timeRegistration.enableCommentsOnTimesheetEntries') }}</material-checkbox>
              </el-tooltip>
              <el-tooltip v-if="enableTimeRegistration" :content="$t('customerSettings.enableBreakButtonTooltip')" placement="right" popper-class="cs-tooltip">
                <material-checkbox v-model="enableBreakButton">{{ $t('timeRegistration.enableBreakButton') }}</material-checkbox>
              </el-tooltip>
              <el-tooltip v-if="enableTimeRegistration" :content="$t('customerSettings.enableTimesheetRemindersTooltip')" placement="right" popper-class="cs-tooltip">
                <material-checkbox v-model="enableTimesheetReminders">{{ $t('timeRegistration.enableTimesheetReminders') }}</material-checkbox>
              </el-tooltip>
              <el-tooltip v-if="enableTimeRegistration" :content="$t('customerSettings.timeRegistrationDefaultAppScreenTooltip')" placement="right" popper-class="cs-tooltip">
                <material-checkbox v-model="timeRegistrationDefaultAppScreen">{{ $t('timeRegistration.timeRegistrationDefaultAppScreen') }}</material-checkbox>
              </el-tooltip>
              <el-tooltip v-if="enableTimeRegistration" :content="$t('customerSettings.enableTimeRegistrationSyncToERPTooltip')" placement="right" popper-class="cs-tooltip">
                <material-checkbox v-model="enableTimeRegistrationSyncToERP">{{ $t('timeRegistration.enableTimeRegistrationSyncToERP') }}</material-checkbox>
              </el-tooltip>
              <el-tooltip v-if="enableTimeRegistration" :content="$t('customerSettings.enableAbsenceViewTooltip')" placement="right" popper-class="cs-tooltip">
                <material-checkbox v-model="enableAbsenceView">{{ $t('timeRegistration.enableAbsenceView') }}</material-checkbox>
              </el-tooltip>
              <el-tooltip v-if="enableTimeRegistration && enableAbsenceView" :content="$t('customerSettings.enableAbsenceSyncToERPTooltip')" placement="right" popper-class="cs-tooltip">
                <material-checkbox v-model="enableAbsenceSyncToERP">{{ $t('timeRegistration.enableAbsenceSyncToERP') }}</material-checkbox>
              </el-tooltip>
              <div v-if="enableTimeRegistration" class="mt-3" style="max-width:200px">
                <label class="form-label text-sm">{{ $t('timeRegistration.autoClockOutTime') }}</label>
                <input v-model="autoClockOutTime" type="time" lang="en-GB" class="form-control form-control-sm" />
              </div>
              <div v-if="enableTimeRegistration && enableTimesheetReminders" class="mt-3" style="max-width:200px">
                <label class="form-label text-sm">{{ $t('timeRegistration.timesheetReminderTime') }}</label>
                <input v-model="timesheetReminderTime" type="time" lang="en-GB" step="900" class="form-control form-control-sm" />
                <small class="text-secondary">{{ $t('timeRegistration.timesheetReminderTimeHint') }}</small>
              </div>
              <div v-if="enableTimeRegistration" class="mt-3" style="max-width:200px">
                <label class="form-label text-sm">{{ $t('timeRegistration.autoDeductBreakMinutes') }}</label>
                <input v-model.number="autoDeductBreakMinutes" type="number" min="0" max="480" step="5" class="form-control form-control-sm" />
                <small class="text-secondary">{{ $t('timeRegistration.autoDeductBreakMinutesHint') }}</small>
              </div>
              <div v-if="enableTimeRegistration && autoDeductBreakMinutes > 0" class="mt-3" style="max-width:200px">
                <label class="form-label text-sm">{{ $t('timeRegistration.autoDeductBreakThresholdHours') }}</label>
                <input v-model.number="autoDeductBreakThresholdHours" type="number" min="0" max="24" step="1" class="form-control form-control-sm" />
                <small class="text-secondary">{{ $t('timeRegistration.autoDeductBreakThresholdHoursHint') }}</small>
              </div>
              <div v-if="enableTimeRegistration && enableTimesheetAdjustments" class="mt-3" style="max-width:200px">
                <label class="form-label text-sm">{{ $t('timeRegistration.adjustedClockInTime') }}</label>
                <input v-model="adjustedClockInTime" type="time" lang="en-GB" class="form-control form-control-sm" />
              </div>
              <div v-if="enableTimeRegistration" class="mt-3" style="max-width:200px">
                <label class="form-label text-sm">{{ $t('timeRegistration.salaryPeriodStartDay') }}</label>
                <input v-model.number="salaryPeriodStartDay" type="number" min="1" max="31" step="1" class="form-control form-control-sm" />
                <small class="text-secondary">{{ $t('timeRegistration.salaryPeriodStartDayHint') }}</small>
              </div>
            </div>

            <div v-show="isTabVisible('reporting')" class="ts-multi-pills__section">
              <h6 class="ts-multi-pills__heading">
                <i class="material-icons">assessment</i>
                <span>{{ $t('customerSettings.reportingSection') }}</span>
              </h6>
              <p class="text-xs text-secondary mb-2">{{ $t('customerSettings.reportingSectionHint') }}</p>
              <div v-for="report in reportConfigs" :key="report.model" class="cs-report-row">
                <material-checkbox v-model="$data[report.model]">{{ $t(report.labelKey) }}</material-checkbox>
                <el-tooltip :content="$t(report.infoKey)" placement="right" popper-class="cs-tooltip">
                  <i class="material-icons cs-info-icon" tabindex="0" role="button" :aria-label="$t(report.labelKey)">info_outline</i>
                </el-tooltip>
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col-sm d-flex justify-content-end">
              <material-button class="mt-3" variant="gradient" color="dark" @click="submitSuperAdminSettings">
                {{$t('common.submit')}}
              </material-button>
            </div>
          </div>
        </card>
      </div>
    </div>
  </div>
</template>

<script>
import ImageUpload from '../../components/ImageUpload.vue';
import Card from '../../components/Card.vue';
import { Form } from 'vee-validate';
import MaterialInputField from "@/components/MaterialInputField.vue";
import MaterialButton from "@/components/MaterialButton.vue";
import MaterialCheckbox from "@/components/MaterialCheckbox.vue";
import { ElTooltip } from 'element-plus';
import api from "../../services/api";
import swal from 'sweetalert2';
import { getCustomerConfigTypeId, loadCustomerConfigs, loadCustomerConfigsCached, getConfigValue } from './customerConfigHelper';
import { loadCustomerMeCached, invalidateCustomerMeCache } from '../../services/customerMeHelper';
import { jwtDecode } from "jwt-decode";
import Cookies from 'js-cookie';

export default {
  components: {
    ImageUpload,
    Card,
    Form,
    MaterialInputField,
    MaterialButton,
    MaterialCheckbox,
    ElTooltip,
  },
  data() {
    return {
      isMobile: window.innerWidth <= 1024,
      visibleSuperAdminTabs: ['projects'],
      images: { regular: null },
      customer: { name: '', logoBytes: null, toolLogoBytes: null },
      contactEmail: '',
      contactPhone: '',
      dayProjectAssignmentsCustomName: '',
      preCreatedDayProjectAssignmentsCustomName: '',
      enableCustomQRBanner: false,
      enableProjectCreation: false,
      enableProjectPrices: false,
      enableProjectTypes: false,
      enableManualProjectPriceSetting: false,
      usePreCreatedAssignmentsFilteringInPlanner: false,
      enablePreCreatedProjectAssignments: false,
      enablePlanner: false,
      plannerDefaultView: 'Day',
      onlyShowUsersWithAssignmentsInPlanner: false,
      enableAssignmentCreationInPlannerMonthView: false,
      enableProjectAssignmentMultiplierInPlanner: false,
      disableRoutinesInPlanner: false,
      disableTaskCreationInPlanner: false,
      disableToolsInPlanner: false,
      onlyShowPreCreatedAssignmentsInPlanner: false,
      useAssignmentStatusColorsInPlanner: false,
      disableCars: false,
      askForToolImageOnReturnForToolReservations: false,
      askForToolImageOnReturnForToolReservationsAfterDays: 1,
      askForToolImageOnReturnForExternalToolReservations: false,
      allowToolReservaAndUnreserveWithourQRScan: false,
      requireQRScanForLoanRentReturns: false,
      allowAllUsersToReturn: false,
      enableMultiRentals: false,
      loanRentCustomer: false,
      enableToolPriceTypes: false,
      allowUsersToMarkBroken: false,
      enableERPCostSync: false,
      enableFutureReservationProjectAssignments: false,
      enableDayProjectAssignments: false,
      enableProjectPhases: false,
      timonUsername: '',
      timonPassword: '',
      originalTimonPassword: '',
      timonUrl: '',
      DKApiKey: '',
      DKWebhookSecret: '',
      DKItemCode: '',
      OriginalDKWebhookSecret: '',
      OriginalDKApiKey: '',
      enableTimeRegistrationSyncToERP: false,
      enableAbsenceView: false,
      enableAbsenceSyncToERP: false,
      enableAutomaticERPSyncForTimeRegistrationEntries: false,
      dkTimeRegAbsenceTypes: ['Sickness', 'ChildSickness', 'Vacation', 'PaidLeave', 'UnpaidLeave', 'ParentalLeave'],
      // Per absence type: projectKey/phaseKey are what gets saved ("projectKey;phaseKey");
      // project is the resolved synced project (for label + phases lookup), phases its options
      dkTimeRegMappings: {
        Sickness: { projectKey: '', phaseKey: '', project: null, phases: [] },
        ChildSickness: { projectKey: '', phaseKey: '', project: null, phases: [] },
        Vacation: { projectKey: '', phaseKey: '', project: null, phases: [] },
        PaidLeave: { projectKey: '', phaseKey: '', project: null, phases: [] },
        UnpaidLeave: { projectKey: '', phaseKey: '', project: null, phases: [] },
        ParentalLeave: { projectKey: '', phaseKey: '', project: null, phases: [] },
      },
      dkTimeRegProjectOptions: [],
      dkTimeRegProjectsLoading: false,
      DKTimeRegAfterHoursTarget: 'OverTime',
      DKTimeRegRedDayHoursTarget: 'OverTime',
      DKTimeRegWorkEntriesBillable: true,
      // BC time registration sync (BusinessCentralEndCustomers): items live-fetched from BC,
      // selection stored as JSON in the BusinessCentralTimeRegItems config
      bcItems: [],
      bcItemsLoading: false,
      // Time reg items show as the editable checklist after a fetch, and as the saved list again after Vista
      bcTimeRegEditing: false,
      bcSelectedItemNumbers: [],
      bcTimeRegItems: [],
      BCTimeRegDefaultItem: '',
      BCTimeRegOvertimeItem: '',
      BCTimeRegAfterHoursTarget: 'OverTime',
      BCTimeRegRedDayHoursTarget: 'OverTime',
      // BC cost sync (BusinessCentralEndCustomers): the single item all reservation costs bill on
      BCCostItem: '',
      defaultPageSize: 10,
      stolpiUsername: '',
      stolpiPassword: '',
      originalStolpiPassword: '',
      erp: '',
      userRole: '',
      allowLocationFilteringForTools: false,
      BCTenantId: '',
      BCClientId: '',
      OriginalBCClientId: '',
      BCClientSecret: '',
      OriginalBCClientSecret: '',
      BCScope: '',
      BCTokenUrl: '',
      BCCompanyId: '',
      BCLocationId: '',
      BCEnvironment: '',
      enableProjectAssignmentTypes: false,
      enableRentalsOnly: false,
      forceProjectConnectionOnRentals: false,
      pickToolsInProjectCostReport: false,
      enableTimeRegistration: false,
      enableTimesheetAdjustments: false,
      allowAdminMoveTimesheetEntry: false,
      allowUsersToEditAndDeleteOwnTimesheetEntries: false,
      enableSimplifiedTimeRegistration: false,
      enableEndOfDayTimeRegistration: false,
      enableReferenceInTimeRegistration: false,
      enableUnfinishedTimeRegistrationDaysInOverview: false,
      enableCustomOvertimeSchedule: false,
      requireGpsClockIn: false,
      enableCommentsOnTimesheetEntries: false,
      autoClockOutTime: '17:00',
      adjustedClockInTime: '08:00',
      salaryPeriodStartDay: 1,
      enableBreakButton: false,
      autoDeductBreakMinutes: 0,
      autoDeductBreakThresholdHours: 5,
      enableTimesheetReminders: false,
      timesheetReminderTime: '18:00',
      timeRegistrationDefaultAppScreen: false,
      reglaUsername: '',
      reglaPassword: '',
      originalReglaPassword: '',
      verklagClientId: '',
      verklagClientSecret: '',
      originalVerklagClientSecret: '',
      unnurClientId: '',
      unnurClientSecret: '',
      originalUnnurClientSecret: '',
      unnurUrl: '',
      enableQRScanForCarToolAssignment: false,
      requireRepairNotes: false,
      allowUsersToAddRemoveCarTools: false,
      allowAssignedUsersToEditVehicles: false,
      forceEndCustomerSelectionOnProjectCreation: false,
      enableEndCustomers: false,
      allowAssigningToolToOtherUser: false,
      enableGolf: false,
      enableGPS: false,
      enableToolReminders: false,
      enableExcelExport: false,
      enableUserGroups: false,
      // Per-report visibility flags (all off by default) — toggled in the Reporting section.
      enableToolUtilizationReport: false,
      enableRevenueReport: false,
      enableLaborByProjectReport: false,
      enableToolDowntimeReport: false,
      enableOverdueReservationsReport: false,
      enableAbsenceReport: false,
      enableAssetRoiReport: false,
      enableEndCustomerBillingReport: false,
      reportConfigs: [
        { model: 'enableToolUtilizationReport', config: 'EnableToolUtilizationReport', labelKey: 'reports.toolUtilizationTitle', infoKey: 'reports.toolUtilizationInfo' },
        { model: 'enableRevenueReport', config: 'EnableRevenueReport', labelKey: 'reports.revenueTitle', infoKey: 'reports.revenueInfo' },
        { model: 'enableLaborByProjectReport', config: 'EnableLaborByProjectReport', labelKey: 'reports.laborByProjectTitle', infoKey: 'reports.laborByProjectInfo' },
        { model: 'enableToolDowntimeReport', config: 'EnableToolDowntimeReport', labelKey: 'reports.toolDowntimeTitle', infoKey: 'reports.toolDowntimeInfo' },
        { model: 'enableOverdueReservationsReport', config: 'EnableOverdueReservationsReport', labelKey: 'reports.overdueReservationsTitle', infoKey: 'reports.overdueReservationsInfo' },
        { model: 'enableAbsenceReport', config: 'EnableAbsenceReport', labelKey: 'reports.absenceTitle', infoKey: 'reports.absenceInfo' },
        { model: 'enableAssetRoiReport', config: 'EnableAssetRoiReport', labelKey: 'reports.assetRoiTitle', infoKey: 'reports.assetRoiInfo' },
        { model: 'enableEndCustomerBillingReport', config: 'EnableEndCustomerBillingReport', labelKey: 'reports.endCustomerBillingTitle', infoKey: 'reports.endCustomerBillingInfo' },
      ],
      projectDataPublisher: '',
      husasmidjanUsername: '',
      husasmidjanPassword: '',
      originalHusasmidjanPassword: ''
    };
  },
  computed: {
    // ERPs with a time registration synchronizer (TimeRegistrationSynchronizerResolver)
    erpSupportsTimeRegSync() {
      return ['DK', 'DKProjectRequests', 'DKWithProjectPhases', 'BusinessCentralEndCustomers'].includes(this.erp);
    },
    // Options for the default/overtime item selects: the live checkbox selection while
    // editing the fetched BC item list, otherwise the previously saved selection.
    bcSelectableItems() {
      if (this.bcTimeRegEditing) {
        return this.bcItems.filter(i => this.bcSelectedItemNumbers.includes(i.number));
      }
      return this.bcTimeRegItems;
    },
    // The fetched BC item list, or just the saved cost item when the list hasn't been fetched
    bcCostItemOptions() {
      if (this.bcItems.length) {
        return this.bcItems;
      }
      if (!this.BCCostItem) {
        return [];
      }
      const known = this.bcTimeRegItems.find(i => i.number === this.BCCostItem);
      return [{ number: this.BCCostItem, displayName: known ? known.displayName : '' }];
    },
    getERPImage() {
      switch (this.erp) {
        case 'DK': case 'DKProjectRequests': case 'DKFinnur': case 'DKWithProjectPhases': return 'img/dk-logo2.png';
        case 'Tímon': return 'img/timon.png';
        case 'Stólpi': return 'img/stolpi.png';
        case 'BusinessCentralCustomers': case 'BusinessCentralEndCustomers': return 'img/business-central-logo.png';
        case 'ReglaIs': return 'img/Regla_logo.png';
        case 'Verklag': return 'img/verklag_logo.png';
        default: return '';
      }
    },
    superAdminTabs() {
      return [
        { key: 'projects', label: this.$t('customerSettings.projectsSection'), icon: 'work' },
        { key: 'endCustomers', label: this.$t('customerSettings.endCustomersSection'), icon: 'people' },
        { key: 'planner', label: this.$t('customerSettings.plannerSection'), icon: 'calendar_month' },
        { key: 'tools', label: this.$t('customerSettings.toolsSection'), icon: 'build' },
        { key: 'cars', label: this.$t('customerSettings.carsSection'), icon: 'directions_car' },
        { key: 'loansRentals', label: this.$t('customerSettings.loansRentalsSection'), icon: 'swap_horiz' },
        { key: 'costReporting', label: this.$t('customerSettings.costReportingSection'), icon: 'request_quote' },
        { key: 'modules', label: this.$t('customerSettings.modulesSection'), icon: 'extension' },
        { key: 'users', label: this.$t('customerSettings.usersSection'), icon: 'group' },
        { key: 'timeRegistration', label: this.$t('customerSettings.timeRegistrationSection'), icon: 'schedule' },
        { key: 'reporting', label: this.$t('customerSettings.reportingSection'), icon: 'assessment' },
      ];
    },
    allSuperAdminTabsVisible() {
      return this.visibleSuperAdminTabs.length === this.superAdminTabs.length;
    },
  },
  created() {
    const token = Cookies.get('accessToken');
    const decodedToken = jwtDecode(token);
    this.userRole = decodedToken.role;
    this.getAllCustomerConfigs();
    this.fetchCustomer();
    window.addEventListener('resize', this.updateIsMobile);
  },
  beforeUnmount() {
    window.removeEventListener('resize', this.updateIsMobile);
  },
  methods: {
    updateIsMobile() {
      this.isMobile = window.innerWidth <= 1024;
    },
    isTabVisible(key) {
      return this.visibleSuperAdminTabs.includes(key);
    },
    toggleSuperAdminTab(key) {
      const idx = this.visibleSuperAdminTabs.indexOf(key);
      if (idx === -1) {
        this.visibleSuperAdminTabs.push(key);
      } else if (this.visibleSuperAdminTabs.length > 1) {
        this.visibleSuperAdminTabs.splice(idx, 1);
      }
    },
    toggleAllSuperAdminTabs() {
      if (this.allSuperAdminTabsVisible) {
        this.visibleSuperAdminTabs = [this.superAdminTabs[0].key];
      } else {
        this.visibleSuperAdminTabs = this.superAdminTabs.map(t => t.key);
      }
    },
    submitCalendarSettings() {
      let url = "/Customers/CustomerConfigurations";
      let body = {
        configurations: [
          { customerConfigurationTypeId: getCustomerConfigTypeId('DayProjectAssignmentsCustomName'), value: String(this.dayProjectAssignmentsCustomName) },
          { customerConfigurationTypeId: getCustomerConfigTypeId('PreCreatedDayProjectAssignmentsCustomName'), value: String(this.preCreatedDayProjectAssignmentsCustomName) }
        ]
      };
      api.post(url, body).then(() => {
        loadCustomerConfigs();
        this.$toast.success(`${this.$t('customerSettings.configurationsUpdated')}`, { timeout: 2000 });
      }).catch(error => {
        console.error('API request error:', error); // eslint-disable-line no-console
        this.$toast.danger(this.$t('common.unableToUpdate'), { timeout: 0 });
      });
    },
    checkIfNumber(input) { return !isNaN(input); },
    // The reminder job runs every 15 minutes, so the send time only makes sense in that increment.
    snapToQuarterHour(time) {
      const m = /^(\d{1,2}):(\d{2})$/.exec(time || '');
      if (!m) return '18:00';
      const total = (Math.round((Number(m[1]) * 60 + Number(m[2])) / 15) * 15) % 1440;
      return `${String(Math.floor(total / 60)).padStart(2, '0')}:${String(total % 60).padStart(2, '0')}`;
    },
    validateGeneralSettings() {
      if (this.defaultPageSize === '' || !this.checkIfNumber(this.defaultPageSize)) {
        this.$toast.danger(this.$t('customerSettings.defaultPageSizeNotNumber'), { timeout: 2000 });
        return false;
      }
      return true;
    },
    submitSuperAdminSettings() {
      let url = "/Customers/CustomerConfigurations";
      let body = {
        configurations: [
          { customerConfigurationTypeId: getCustomerConfigTypeId('EnableCustomQRBanner'), value: String(this.enableCustomQRBanner) },
          { customerConfigurationTypeId: getCustomerConfigTypeId('EnableProjectCreation'), value: String(this.enableProjectCreation) },
          { customerConfigurationTypeId: getCustomerConfigTypeId('EnablePreCreatedProjectAssignments'), value: String(this.enablePreCreatedProjectAssignments) },
          { customerConfigurationTypeId: getCustomerConfigTypeId('EnableManualProjectPriceSetting'), value: String(this.enableManualProjectPriceSetting) },
          { customerConfigurationTypeId: getCustomerConfigTypeId('EnableProjectPrices'), value: String(this.enableProjectPrices) },
          { customerConfigurationTypeId: getCustomerConfigTypeId('EnableProjectTypes'), value: String(this.enableProjectTypes) },
          { customerConfigurationTypeId: getCustomerConfigTypeId('UsePreCreatedAssignmentsFilteringInPlanner'), value: String(this.usePreCreatedAssignmentsFilteringInPlanner) },
          { customerConfigurationTypeId: getCustomerConfigTypeId('EnablePlanner'), value: String(this.enablePlanner) },
          { customerConfigurationTypeId: getCustomerConfigTypeId('PlannerDefaultView'), value: String(this.plannerDefaultView) },
          { customerConfigurationTypeId: getCustomerConfigTypeId('OnlyShowUsersWithAssignmentsInPlanner'), value: String(this.onlyShowUsersWithAssignmentsInPlanner) },
          { customerConfigurationTypeId: getCustomerConfigTypeId('EnableAssignmentCreationInPlannerMonthView'), value: String(this.enableAssignmentCreationInPlannerMonthView) },
          { customerConfigurationTypeId: getCustomerConfigTypeId('EnableProjectAssignmentMultiplierInPlanner'), value: String(this.enableProjectAssignmentMultiplierInPlanner) },
          { customerConfigurationTypeId: getCustomerConfigTypeId('DisableRoutinesInPlanner'), value: String(this.disableRoutinesInPlanner) },
          { customerConfigurationTypeId: getCustomerConfigTypeId('DisableTaskCreationInPlanner'), value: String(this.disableTaskCreationInPlanner) },
          { customerConfigurationTypeId: getCustomerConfigTypeId('DisableToolsInPlanner'), value: String(this.disableToolsInPlanner) },
          { customerConfigurationTypeId: getCustomerConfigTypeId('OnlyShowPreCreatedAssignmentsInPlanner'), value: String(this.onlyShowPreCreatedAssignmentsInPlanner) },
          { customerConfigurationTypeId: getCustomerConfigTypeId('UseAssignmentStatusColorsInPlanner'), value: String(this.useAssignmentStatusColorsInPlanner) },
          { customerConfigurationTypeId: getCustomerConfigTypeId('EnableToolPriceTypes'), value: String(this.enableToolPriceTypes) },
          { customerConfigurationTypeId: getCustomerConfigTypeId('AllowUsersToMarkBroken'), value: String(this.allowUsersToMarkBroken) },
          { customerConfigurationTypeId: getCustomerConfigTypeId('EnableERPCostSync'), value: String(this.enableERPCostSync) },
          { customerConfigurationTypeId: getCustomerConfigTypeId('EnableMultiRentals'), value: String(this.enableMultiRentals) },
          { customerConfigurationTypeId: getCustomerConfigTypeId('LoanRentCustomer'), value: String(this.loanRentCustomer) },
          { customerConfigurationTypeId: getCustomerConfigTypeId('EnableFutureReservationProjectAssignments'), value: String(this.enableFutureReservationProjectAssignments) },
          { customerConfigurationTypeId: getCustomerConfigTypeId('EnableDayProjectAssignments'), value: String(this.enableDayProjectAssignments) },
          { customerConfigurationTypeId: getCustomerConfigTypeId('EnableProjectPhases'), value: String(this.enableProjectPhases) },
          { customerConfigurationTypeId: getCustomerConfigTypeId('AllowLocationFilteringForTools'), value: String(this.allowLocationFilteringForTools) },
          { customerConfigurationTypeId: getCustomerConfigTypeId('EnableProjectAssignmentTypes'), value: String(this.enableProjectAssignmentTypes) },
          { customerConfigurationTypeId: getCustomerConfigTypeId('EnableRentalsOnly'), value: String(this.enableRentalsOnly) },
          { customerConfigurationTypeId: getCustomerConfigTypeId('ForceProjectConnectionOnRentals'), value: String(this.forceProjectConnectionOnRentals) },
          { customerConfigurationTypeId: getCustomerConfigTypeId('PickToolsInProjectCostReport'), value: String(this.pickToolsInProjectCostReport) },
          { customerConfigurationTypeId: getCustomerConfigTypeId('EnableQRScanForCarToolAssignment'), value: String(this.enableQRScanForCarToolAssignment) },
          { customerConfigurationTypeId: getCustomerConfigTypeId('RequireRepairNotes'), value: String(this.requireRepairNotes) },
          { customerConfigurationTypeId: getCustomerConfigTypeId('AllowUsersToAddRemoveCarTools'), value: String(this.allowUsersToAddRemoveCarTools) },
          { customerConfigurationTypeId: getCustomerConfigTypeId('AllowAssignedUsersToEditVehicles'), value: String(this.allowAssignedUsersToEditVehicles) },
          { customerConfigurationTypeId: getCustomerConfigTypeId('ForceEndCustomerSelectionOnProjectCreation'), value: String(this.forceEndCustomerSelectionOnProjectCreation) },
          { customerConfigurationTypeId: getCustomerConfigTypeId('EnableEndCustomers'), value: String(this.enableEndCustomers) },
          { customerConfigurationTypeId: getCustomerConfigTypeId('AllowAssigningToolToOtherUser'), value: String(this.allowAssigningToolToOtherUser) },
          { customerConfigurationTypeId: getCustomerConfigTypeId('EnableGolf'), value: String(this.enableGolf) },
          { customerConfigurationTypeId: getCustomerConfigTypeId('EnableGPS'), value: String(this.enableGPS) },
          { customerConfigurationTypeId: getCustomerConfigTypeId('EnableToolReminders'), value: String(this.enableToolReminders) },
          { customerConfigurationTypeId: getCustomerConfigTypeId('EnableExcelExport'), value: String(this.enableExcelExport) },
          { customerConfigurationTypeId: getCustomerConfigTypeId('EnableUserGroups'), value: String(this.enableUserGroups) },
          { customerConfigurationTypeId: getCustomerConfigTypeId('EnableTimeRegistration'), value: String(this.enableTimeRegistration) },
          { customerConfigurationTypeId: getCustomerConfigTypeId('EnableTimesheetAdjustments'), value: String(this.enableTimesheetAdjustments) },
          { customerConfigurationTypeId: getCustomerConfigTypeId('AllowAdminMoveTimesheetEntry'), value: String(this.allowAdminMoveTimesheetEntry) },
          { customerConfigurationTypeId: getCustomerConfigTypeId('AllowUsersToEditAndDeleteOwnTimesheetEntries'), value: String(this.allowUsersToEditAndDeleteOwnTimesheetEntries) },
          { customerConfigurationTypeId: getCustomerConfigTypeId('EnableSimplifiedTimeRegistration'), value: String(this.enableSimplifiedTimeRegistration) },
          { customerConfigurationTypeId: getCustomerConfigTypeId('EnableEndOfDayTimeRegistration'), value: String(this.enableEndOfDayTimeRegistration) },
          { customerConfigurationTypeId: getCustomerConfigTypeId('EnableReferenceInTimeRegistration'), value: String(this.enableReferenceInTimeRegistration) },
          { customerConfigurationTypeId: getCustomerConfigTypeId('EnableUnfinishedTimeRegistrationDaysInOverview'), value: String(this.enableUnfinishedTimeRegistrationDaysInOverview) },
          { customerConfigurationTypeId: getCustomerConfigTypeId('EnableCustomOvertimeSchedule'), value: String(this.enableCustomOvertimeSchedule) },
          { customerConfigurationTypeId: getCustomerConfigTypeId('RequireGpsClockIn'), value: String(this.requireGpsClockIn) },
          { customerConfigurationTypeId: getCustomerConfigTypeId('EnableCommentsOnTimesheetEntries'), value: String(this.enableCommentsOnTimesheetEntries) },
          { customerConfigurationTypeId: getCustomerConfigTypeId('AutoClockOutTime'), value: String(this.autoClockOutTime || '17:00') },
          { customerConfigurationTypeId: getCustomerConfigTypeId('AdjustedClockInTime'), value: String(this.adjustedClockInTime || '08:00') },
          { customerConfigurationTypeId: getCustomerConfigTypeId('SalaryPeriodStartDay'), value: String(Math.min(31, Math.max(1, Math.floor(Number(this.salaryPeriodStartDay) || 1)))) },
          { customerConfigurationTypeId: getCustomerConfigTypeId('EnableBreakButton'), value: String(this.enableBreakButton) },
          { customerConfigurationTypeId: getCustomerConfigTypeId('AutoDeductBreakMinutes'), value: String(Math.min(480, Math.max(0, Math.floor(Number(this.autoDeductBreakMinutes) || 0)))) },
          { customerConfigurationTypeId: getCustomerConfigTypeId('AutoDeductBreakThresholdHours'), value: String(Math.min(24, Math.max(0, Math.floor(Number(this.autoDeductBreakThresholdHours) || 5)))) },
          { customerConfigurationTypeId: getCustomerConfigTypeId('EnableTimesheetReminders'), value: String(this.enableTimesheetReminders) },
          { customerConfigurationTypeId: getCustomerConfigTypeId('TimesheetReminderTime'), value: this.snapToQuarterHour(this.timesheetReminderTime) },
          { customerConfigurationTypeId: getCustomerConfigTypeId('TimeRegistrationDefaultAppScreen'), value: String(this.timeRegistrationDefaultAppScreen) },
          { customerConfigurationTypeId: getCustomerConfigTypeId('EnableTimeRegistrationSyncToERP'), value: String(this.enableTimeRegistrationSyncToERP) },
          { customerConfigurationTypeId: getCustomerConfigTypeId('EnableAbsenceView'), value: String(this.enableAbsenceView) },
          { customerConfigurationTypeId: getCustomerConfigTypeId('EnableAbsenceSyncToERP'), value: String(this.enableAbsenceSyncToERP) },
          ...this.reportConfigs.map(r => ({ customerConfigurationTypeId: getCustomerConfigTypeId(r.config), value: String(this[r.model]) }))
        ]
      };
      api.post(url, body).then(() => {
        loadCustomerConfigs();
        this.$toast.success(`${this.$t('customerSettings.configurationsUpdated')}`, { timeout: 2000 });
      }).catch(error => {
        console.error('API request error:', error); // eslint-disable-line no-console
        this.$toast.danger(this.$t('common.unableToUpdate'), { timeout: 0 });
      });
    },
    submitProjectDataPublisherSettings() {
      let body = {
        configurations: [
          { customerConfigurationTypeId: getCustomerConfigTypeId('ProjectDataPublisher'), value: String(this.projectDataPublisher) }
        ]
      };
      switch (this.projectDataPublisher) {
        case '':
          break;
        case 'Husasmidjan':
          body.configurations.push({ customerConfigurationTypeId: getCustomerConfigTypeId('HusasmidjanUsername'), value: this.husasmidjanUsername });
          if (this.husasmidjanPassword !== this.originalHusasmidjanPassword) body.configurations.push({ customerConfigurationTypeId: getCustomerConfigTypeId('HusasmidjanPassword'), value: this.husasmidjanPassword });
          break;
        default:
          this.$toast.danger(this.$t('customerSettings.unknownProjectDataPublisher') + ' - ' + this.projectDataPublisher, { timeout: 0 });
          return;
      }
      let url = "/Customers/CustomerConfigurations";
      api.post(url, body).then(() => {
        loadCustomerConfigs().then(() => {
          this.getAllCustomerConfigs();
          this.$toast.success(`${this.$t('customerSettings.configurationsUpdated')}`, { timeout: 2000 });
        });
      }).catch(error => {
        console.error('API request error:', error); // eslint-disable-line no-console
        this.$toast.danger(this.$t('common.unableToUpdate'), { timeout: 0 });
      });
    },
    async loadBcItems() {
      this.bcItemsLoading = true;
      try {
        const r = await api.get('/Customers/BusinessCentralItems');
        this.bcItems = (r.data.value || r.data || []).slice().sort((a, b) => a.number.localeCompare(b.number, undefined, { numeric: true }));
        this.bcSelectedItemNumbers = this.bcTimeRegItems.map(i => i.number);
        this.bcTimeRegEditing = true;
      } catch (error) {
        console.error('API request error:', error); // eslint-disable-line no-console
        this.$toast.danger(this.$t('customerSettings.bcTimeRegLoadItemsFailed'), { timeout: 0 });
      } finally {
        this.bcItemsLoading = false;
      }
    },
    dkTimeRegOptionsFor(type) {
      // Keep the selected project visible even when the remote search results no longer contain it.
      // If the saved key couldn't be resolved to a synced project, still show the raw key instead of a blank select.
      const m = this.dkTimeRegMappings[type];
      const selected = m.project || (m.projectKey ? { key: m.projectKey, name: m.projectKey } : null);
      if (selected && !this.dkTimeRegProjectOptions.some(p => p.key === selected.key)) {
        return [selected, ...this.dkTimeRegProjectOptions];
      }
      return this.dkTimeRegProjectOptions;
    },
    async dkTimeRegSearchProjects(query) {
      this.dkTimeRegProjectsLoading = true;
      try {
        const r = await api.get(`/Project?searchString=${encodeURIComponent(query || '')}&currentPage=1&pageSize=50`);
        const items = r.data.result ?? r.data.items ?? r.data;
        this.dkTimeRegProjectOptions = (items || []).map(p => ({ id: p.id?.value ?? p.id, key: p.key, name: p.name }));
      } catch (e) {
        console.error('dkTimeRegSearchProjects error:', e); // eslint-disable-line no-console
      } finally {
        this.dkTimeRegProjectsLoading = false;
      }
    },
    async dkTimeRegProjectChanged(type) {
      const m = this.dkTimeRegMappings[type];
      m.phaseKey = '';
      m.phases = [];
      m.project = this.dkTimeRegProjectOptions.find(p => p.key === m.projectKey) || null;
      await this.dkTimeRegFetchPhases(type);
    },
    async dkTimeRegFetchPhases(type) {
      const m = this.dkTimeRegMappings[type];
      if (!m.project || !m.project.id) return;
      try {
        const r = await api.get(`/Project/${m.project.id}/Phases`);
        m.phases = (r.data || []).map(ph => ({ key: ph.key, name: ph.name }));
      } catch (e) {
        console.error('dkTimeRegFetchPhases error:', e); // eslint-disable-line no-console
      }
    },
    async initDkTimeRegMappings() {
      // Resolve saved project keys to synced projects so the dropdowns show names and phase options
      if (!this.enableTimeRegistrationSyncToERP) return;
      for (const t of this.dkTimeRegAbsenceTypes) {
        const m = this.dkTimeRegMappings[t];
        if (!m.projectKey) continue;
        try {
          const r = await api.get(`/Project?searchString=${encodeURIComponent(m.projectKey)}&currentPage=1&pageSize=15`);
          const items = r.data.result ?? r.data.items ?? r.data;
          const match = (items || [])
            .map(p => ({ id: p.id?.value ?? p.id, key: p.key, name: p.name }))
            .find(p => p.key === m.projectKey);
          if (match) {
            m.project = match;
            await this.dkTimeRegFetchPhases(t);
          }
        } catch (e) {
          console.error('initDkTimeRegMappings error:', e); // eslint-disable-line no-console
        }
      }
    },
    submitERPSettings() {
      let body = { configurations: [] };
      switch (this.erp) {
        case 'DK': case 'DKProjectRequests': case 'DKFinnur': case 'DKWithProjectPhases':
          body.configurations.push({ customerConfigurationTypeId: getCustomerConfigTypeId('DKItemCode'), value: this.DKItemCode });
          if (this.DKApiKey !== this.OriginalDKApiKey) body.configurations.push({ customerConfigurationTypeId: getCustomerConfigTypeId('DKApiKey'), value: this.DKApiKey });
          if (this.DKWebhookSecret !== this.OriginalDKWebhookSecret) body.configurations.push({ customerConfigurationTypeId: getCustomerConfigTypeId('DKWebhookSecret'), value: this.DKWebhookSecret });
          if (this.enableTimeRegistrationSyncToERP) {
            for (const t of this.dkTimeRegAbsenceTypes) {
              const m = this.dkTimeRegMappings[t];
              const value = m.projectKey ? (m.phaseKey ? `${m.projectKey};${m.phaseKey}` : m.projectKey) : '';
              body.configurations.push({ customerConfigurationTypeId: getCustomerConfigTypeId(`DKTimeReg${t}Mapping`), value });
            }
            body.configurations.push({ customerConfigurationTypeId: getCustomerConfigTypeId('DKTimeRegAfterHoursTarget'), value: this.DKTimeRegAfterHoursTarget });
            body.configurations.push({ customerConfigurationTypeId: getCustomerConfigTypeId('DKTimeRegRedDayHoursTarget'), value: this.DKTimeRegRedDayHoursTarget });
            body.configurations.push({ customerConfigurationTypeId: getCustomerConfigTypeId('DKTimeRegWorkEntriesBillable'), value: String(this.DKTimeRegWorkEntriesBillable) });
          }
          break;
        case 'Tímon':
          if (this.timonPassword !== this.originalTimonPassword) body.configurations.push({ customerConfigurationTypeId: getCustomerConfigTypeId('TimonPassword'), value: this.timonPassword });
          body.configurations.push({ customerConfigurationTypeId: getCustomerConfigTypeId('TimonUsername'), value: this.timonUsername });
          body.configurations.push({ customerConfigurationTypeId: getCustomerConfigTypeId('TimonUrl'), value: this.timonUrl });
          break;
        case 'Stólpi':
          if (this.stolpiPassword !== this.originalStolpiPassword) body.configurations.push({ customerConfigurationTypeId: getCustomerConfigTypeId('StolpiPassword'), value: this.stolpiPassword });
          body.configurations.push({ customerConfigurationTypeId: getCustomerConfigTypeId('StolpiUsername'), value: this.stolpiUsername });
          break;
        case 'BusinessCentralCustomers': case 'BusinessCentralEndCustomers':
          if (this.BCClientId !== this.OriginalBCClientId) body.configurations.push({ customerConfigurationTypeId: getCustomerConfigTypeId('BusinessCentralCustomersClientId'), value: this.BCClientId });
          if (this.BCClientSecret !== this.OriginalBCClientSecret) body.configurations.push({ customerConfigurationTypeId: getCustomerConfigTypeId('BusinessCentralCustomersClientSecret'), value: this.BCClientSecret });
          body.configurations.push({ customerConfigurationTypeId: getCustomerConfigTypeId('BusinessCentralCustomersTenantId'), value: this.BCTenantId });
          body.configurations.push({ customerConfigurationTypeId: getCustomerConfigTypeId('BusinessCentralCustomersClientScope'), value: this.BCScope });
          body.configurations.push({ customerConfigurationTypeId: getCustomerConfigTypeId('BusinessCentralCustomersTokenUrl'), value: this.BCTokenUrl });
          body.configurations.push({ customerConfigurationTypeId: getCustomerConfigTypeId('BusinessCentralCustomersCompanyId'), value: this.BCCompanyId });
          body.configurations.push({ customerConfigurationTypeId: getCustomerConfigTypeId('BusinessCentralCustomersLocationId'), value: this.BCLocationId });
          body.configurations.push({ customerConfigurationTypeId: getCustomerConfigTypeId('BusinessCentralCustomersEnvironment'), value: this.BCEnvironment });
          if (this.erp === 'BusinessCentralEndCustomers' && this.enableTimeRegistrationSyncToERP) {
            const selectedItems = this.bcTimeRegEditing
              ? this.bcItems.filter(i => this.bcSelectedItemNumbers.includes(i.number)).map(i => ({ number: i.number, displayName: i.displayName }))
              : this.bcTimeRegItems;
            body.configurations.push({ customerConfigurationTypeId: getCustomerConfigTypeId('BusinessCentralTimeRegItems'), value: JSON.stringify(selectedItems) });
            body.configurations.push({ customerConfigurationTypeId: getCustomerConfigTypeId('BusinessCentralTimeRegDefaultItem'), value: this.BCTimeRegDefaultItem });
            body.configurations.push({ customerConfigurationTypeId: getCustomerConfigTypeId('BusinessCentralTimeRegOvertimeItem'), value: this.BCTimeRegOvertimeItem });
            body.configurations.push({ customerConfigurationTypeId: getCustomerConfigTypeId('BusinessCentralTimeRegAfterHoursTarget'), value: this.BCTimeRegAfterHoursTarget });
            body.configurations.push({ customerConfigurationTypeId: getCustomerConfigTypeId('BusinessCentralTimeRegRedDayHoursTarget'), value: this.BCTimeRegRedDayHoursTarget });
          }
          if (this.erp === 'BusinessCentralEndCustomers' && this.enableERPCostSync) {
            body.configurations.push({ customerConfigurationTypeId: getCustomerConfigTypeId('BusinessCentralCostItem'), value: this.BCCostItem });
          }
          break;
        case 'ReglaIs':
          if (this.reglaPassword !== this.originalReglaPassword) body.configurations.push({ customerConfigurationTypeId: getCustomerConfigTypeId('ReglaPassword'), value: this.reglaPassword });
          body.configurations.push({ customerConfigurationTypeId: getCustomerConfigTypeId('ReglaUsername'), value: this.reglaUsername });
          break;
        case 'Verklag':
          body.configurations.push({ customerConfigurationTypeId: getCustomerConfigTypeId('VerklagClientId'), value: this.verklagClientId });
          if (this.verklagClientSecret !== this.originalVerklagClientSecret) body.configurations.push({ customerConfigurationTypeId: getCustomerConfigTypeId('VerklagClientSecret'), value: this.verklagClientSecret });
          break;
        case 'Unnur':
          body.configurations.push({ customerConfigurationTypeId: getCustomerConfigTypeId('UnnurClientId'), value: this.unnurClientId });
          if (this.unnurClientSecret !== this.originalUnnurClientSecret) body.configurations.push({ customerConfigurationTypeId: getCustomerConfigTypeId('UnnurClientSecret'), value: this.unnurClientSecret });
          body.configurations.push({ customerConfigurationTypeId: getCustomerConfigTypeId('UnnurUrl'), value: this.unnurUrl });
          break;
        default:
          this.$toast.danger(this.$t('customerSettings.unknownERP') + ' - ' + this.erp, { timeout: 0 });
          return;
      }
      if (this.erpSupportsTimeRegSync && this.enableTimeRegistrationSyncToERP) {
        body.configurations.push({ customerConfigurationTypeId: getCustomerConfigTypeId('EnableAutomaticERPSyncForTimeRegistrationEntries'), value: String(this.enableAutomaticERPSyncForTimeRegistrationEntries) });
      }
      if (body.configurations.length <= 0) {
        this.$toast.warning(this.$t('customerSettings.nothingToUpdate'), { timeout: 2000 });
        return;
      }
      let url = "/Customers/CustomerConfigurations";
      api.post(url, body).then(() => {
        loadCustomerConfigs().then(() => {
          this.getAllCustomerConfigs();
          this.bcTimeRegEditing = false;
          this.$toast.success(`${this.$t('customerSettings.configurationsUpdated')}`, { timeout: 2000 });
        });
      }).catch(error => {
        console.error('API request error:', error); // eslint-disable-line no-console
        this.$toast.danger(this.$t('common.unableToUpdate'), { timeout: 0 });
      });
    },
    clampAskForToolImageDays() {
      const n = Number(this.askForToolImageOnReturnForToolReservationsAfterDays);
      if (!Number.isFinite(n) || n < 1) {
        this.askForToolImageOnReturnForToolReservationsAfterDays = 1;
      } else {
        this.askForToolImageOnReturnForToolReservationsAfterDays = Math.floor(n);
      }
    },
    submitGeneralSettings() {
      if (!this.validateGeneralSettings()) return;
      this.clampAskForToolImageDays();
      let url = "/Customers/CustomerConfigurations";
      let body = {
        configurations: [
          { customerConfigurationTypeId: getCustomerConfigTypeId('DefaultPageSize'), value: String(this.defaultPageSize) },
          { customerConfigurationTypeId: getCustomerConfigTypeId('DisableCars'), value: String(this.disableCars) },
          { customerConfigurationTypeId: getCustomerConfigTypeId('AskForToolImageOnReturnForToolReservations'), value: String(this.askForToolImageOnReturnForToolReservations) },
          { customerConfigurationTypeId: getCustomerConfigTypeId('AskForToolImageOnReturnForToolReservationsAfterDays'), value: String(this.askForToolImageOnReturnForToolReservationsAfterDays) },
          { customerConfigurationTypeId: getCustomerConfigTypeId('AskForToolImageOnReturnForExternalToolReservations'), value: String(this.askForToolImageOnReturnForExternalToolReservations) },
          { customerConfigurationTypeId: getCustomerConfigTypeId('AllowToolReservaAndUnreserveWithourQRScan'), value: String(this.allowToolReservaAndUnreserveWithourQRScan) },
          { customerConfigurationTypeId: getCustomerConfigTypeId('RequireQRScanForLoanRentReturns'), value: String(this.requireQRScanForLoanRentReturns) },
          { customerConfigurationTypeId: getCustomerConfigTypeId('AllowAllUsersToReturn'), value: String(this.allowAllUsersToReturn) },
        ]
      };
      api.post(url, body).then(() => {
        loadCustomerConfigs();
        this.$toast.success(`${this.$t('customerSettings.configurationsUpdated')}`, { timeout: 2000 });
      }).catch(error => {
        console.error('API request error:', error); // eslint-disable-line no-console
        this.$toast.danger(this.$t('common.unableToUpdate'), { timeout: 0 });
      });
    },
    submitContactInfo() {
      let url = "Customers/Update/Contact";
      let body = {
        contactEmail: this.contactEmail,
        contactPhone: this.contactPhone
      };
      api.put(url, body).then(() => {
        invalidateCustomerMeCache();
        this.$toast.success(`${this.$t('customerSettings.configurationsUpdated')}`, { timeout: 2000 });
      }).catch(error => {
        console.error('API request error:', error); // eslint-disable-line no-console
        this.$toast.danger(this.$t('common.unableToUpdate'), { timeout: 0 });
      });
    },
    onImageChange(file) { this.images.regular = file; },
    handleDelete(key) {
      swal.fire({ title: this.$t('delete.areYouSure'), text: this.$t('delete.noRevert'), icon: 'warning', showCancelButton: true, customClass: { confirmButton: 'btn btn-success btn-fill', cancelButton: 'btn btn-danger btn-fill' }, confirmButtonText: this.$t('delete.yesDeleteIt'), cancelButtonText: this.$t('delete.cancel'), buttonsStyling: false }).then(result => {
        if (result.value) {
          this.deleteCustomerSetting(key);
          swal.fire({ title: this.$t('delete.deleted'), text: `${this.$t('delete.youDeleted')} ${key}`, icon: 'success', customClass: { confirmButton: 'btn btn-success btn-fill' }, buttonsStyling: false });
        }
      });
    },
    deleteCustomerSetting(key) {
      api.delete(`/Customers/CustomerSettings/` + key).then(() => { this.tableData = this.tableData.filter(s => s.key !== key); }).catch(error => { console.error('API request error:', error); }); // eslint-disable-line no-console
    },
    fetchData() {
      api.get("Customers/CustomerSettings").then(response => {
        this.tableData = response.data.map(item => ({ key: item.key, value: item.value, encrypted: item.encrypted }));
      }).catch(error => {
        console.error('API request error:', error); // eslint-disable-line no-console
        this.$toast.danger(this.$t('common.unableToRetrieveData'), { timeout: 2000 });
      });
    },
    fetchCustomer() {
      loadCustomerMeCached().then(customer => {
        const response = { data: { value: customer } };
        this.erp = response.data.value.erpName;
        this.customer.name = response.data.value.name;
        this.contactEmail = response.data.value.contactEmail || '';
        this.contactPhone = response.data.value.contactPhone || '';
        if (response.data.value.logoBytes) {
          this.customer.logoBytes = response.data.value.logoBytes;
          let byteCharacters = atob(this.customer.logoBytes);
          let byteNumbers = new Array(byteCharacters.length);
          for (let i = 0; i < byteCharacters.length; i++) byteNumbers[i] = byteCharacters.charCodeAt(i);
          let byteArray = new Uint8Array(byteNumbers);
          let blob = new Blob([byteArray], { type: "image/png" });
          this.images.regular = URL.createObjectURL(blob);
        }
        if (response.data.value.toolLogoBytes) {
          this.customer.toolLogoBytes = response.data.value.toolLogoBytes;
          let byteCharacters = atob(this.customer.toolLogoBytes);
          let byteNumbers = new Array(byteCharacters.length);
          for (let i = 0; i < byteCharacters.length; i++) byteNumbers[i] = byteCharacters.charCodeAt(i);
          let byteArray = new Uint8Array(byteNumbers);
          let blob = new Blob([byteArray], { type: "image/png" });
          this.images.regular = URL.createObjectURL(blob);
        }
      }).catch(error => {
        console.error('API request error:', error); // eslint-disable-line no-console
        this.$toast.danger(this.$t('common.unableToRetrieveData'), { timeout: 0 });
      });
    },
    onUpload(isCustomerLogo) {
      let reader = new FileReader();
      reader.onloadend = () => {
        let base64String = reader.result.replace(/^data:.+;base64,/, '');
        let url = "Customers/Update/Logo";
        let body = isCustomerLogo ? { logoBytes: base64String } : { toolLogoBytes: base64String };
        api.put(url, body).then(() => {
          invalidateCustomerMeCache();
          this.$toast.success(this.$t('customerSettings.logoUpdated'), { timeout: 2000 });
          this.fetchCustomer();
        }).catch(error => {
          console.error('API request error:', error); // eslint-disable-line no-console
          this.$toast.danger(this.$t('common.unableToUpdate'), { timeout: 0 });
        });
      };
      reader.readAsDataURL(this.images.regular);
    },
    async getAllCustomerConfigs() {
      const configs = await loadCustomerConfigsCached();
      if (!configs) {
        console.error('Unable to load customer configs'); // eslint-disable-line no-console
        return;
      }
      const val = (type) => getConfigValue(configs, type);
      const bool = (type) => { const v = val(type); return v === '' ? false : v; };
      // Raw string value — getConfigValue coerces numeric-looking values to Number, which would
      // break values like the DK mapping "0004" (TypeError on .split, and 0004 -> 4 loses zeros)
      const rawVal = (type) => {
        const match = configs.find(c => c.customerConfigurationType.type === type);
        return match && match.value != null ? String(match.value) : '';
      };

      // General settings
      this.defaultPageSize = val('DefaultPageSize');
      this.disableCars = bool('DisableCars');
      this.askForToolImageOnReturnForToolReservations = bool('AskForToolImageOnReturnForToolReservations');
      const daysVal = val('AskForToolImageOnReturnForToolReservationsAfterDays');
      this.askForToolImageOnReturnForToolReservationsAfterDays = Number.isFinite(Number(daysVal)) && Number(daysVal) >= 1 ? Math.floor(Number(daysVal)) : 1;
      this.askForToolImageOnReturnForExternalToolReservations = bool('AskForToolImageOnReturnForExternalToolReservations');
      this.allowToolReservaAndUnreserveWithourQRScan = bool('AllowToolReservaAndUnreserveWithourQRScan');
      this.requireQRScanForLoanRentReturns = bool('RequireQRScanForLoanRentReturns');
      this.allowAllUsersToReturn = bool('AllowAllUsersToReturn');
      this.enableQRScanForCarToolAssignment = bool('EnableQRScanForCarToolAssignment');
      this.requireRepairNotes = bool('RequireRepairNotes');
      this.allowUsersToAddRemoveCarTools = bool('AllowUsersToAddRemoveCarTools');
      this.allowAssignedUsersToEditVehicles = bool('AllowAssignedUsersToEditVehicles');

      // Super admin settings
      this.enableCustomQRBanner = bool('EnableCustomQRBanner');
      this.enableProjectCreation = bool('EnableProjectCreation');
      this.projectDataPublisher = val('ProjectDataPublisher') || '';
      this.enablePreCreatedProjectAssignments = bool('EnablePreCreatedProjectAssignments');
      this.enableManualProjectPriceSetting = bool('EnableManualProjectPriceSetting');
      this.enableProjectPrices = bool('EnableProjectPrices');
      this.enableProjectTypes = bool('EnableProjectTypes');
      this.usePreCreatedAssignmentsFilteringInPlanner = bool('UsePreCreatedAssignmentsFilteringInPlanner');
      this.enablePlanner = bool('EnablePlanner');
      this.plannerDefaultView = val('PlannerDefaultView') || 'Day';
      this.onlyShowUsersWithAssignmentsInPlanner = bool('OnlyShowUsersWithAssignmentsInPlanner');
      this.enableAssignmentCreationInPlannerMonthView = bool('EnableAssignmentCreationInPlannerMonthView');
      this.enableProjectAssignmentMultiplierInPlanner = bool('EnableProjectAssignmentMultiplierInPlanner');
      this.disableRoutinesInPlanner = bool('DisableRoutinesInPlanner');
      this.disableTaskCreationInPlanner = bool('DisableTaskCreationInPlanner');
      this.disableToolsInPlanner = bool('DisableToolsInPlanner');
      this.onlyShowPreCreatedAssignmentsInPlanner = bool('OnlyShowPreCreatedAssignmentsInPlanner');
      this.useAssignmentStatusColorsInPlanner = bool('UseAssignmentStatusColorsInPlanner');
      this.enableToolPriceTypes = bool('EnableToolPriceTypes');
      this.allowUsersToMarkBroken = bool('AllowUsersToMarkBroken');
      this.enableERPCostSync = bool('EnableERPCostSync');
      this.enableMultiRentals = bool('EnableMultiRentals');
      this.loanRentCustomer = bool('LoanRentCustomer');
      this.enableFutureReservationProjectAssignments = bool('EnableFutureReservationProjectAssignments');
      this.enableDayProjectAssignments = bool('EnableDayProjectAssignments');
      this.enableProjectPhases = bool('EnableProjectPhases');
      this.allowLocationFilteringForTools = bool('AllowLocationFilteringForTools');
      this.enableProjectAssignmentTypes = bool('EnableProjectAssignmentTypes');
      this.enableRentalsOnly = bool('EnableRentalsOnly');
      this.forceProjectConnectionOnRentals = bool('ForceProjectConnectionOnRentals');
      this.pickToolsInProjectCostReport = bool('PickToolsInProjectCostReport');
      this.forceEndCustomerSelectionOnProjectCreation = bool('ForceEndCustomerSelectionOnProjectCreation');
      this.enableEndCustomers = bool('EnableEndCustomers');
      this.allowAssigningToolToOtherUser = bool('AllowAssigningToolToOtherUser');
      this.enableGolf = bool('EnableGolf');
      this.enableGPS = bool('EnableGPS');
      this.enableToolReminders = bool('EnableToolReminders');
      this.enableExcelExport = bool('EnableExcelExport');
      this.enableUserGroups = bool('EnableUserGroups');

      // Per-report visibility flags
      this.reportConfigs.forEach(r => { this[r.model] = bool(r.config); });

      // Time registration settings
      this.enableTimeRegistration = bool('EnableTimeRegistration');
      this.enableTimesheetAdjustments = bool('EnableTimesheetAdjustments');
      this.allowAdminMoveTimesheetEntry = bool('AllowAdminMoveTimesheetEntry');
      this.allowUsersToEditAndDeleteOwnTimesheetEntries = bool('AllowUsersToEditAndDeleteOwnTimesheetEntries');
      this.enableSimplifiedTimeRegistration = bool('EnableSimplifiedTimeRegistration');
      this.enableEndOfDayTimeRegistration = bool('EnableEndOfDayTimeRegistration');
      this.enableReferenceInTimeRegistration = bool('EnableReferenceInTimeRegistration');
      this.enableUnfinishedTimeRegistrationDaysInOverview = bool('EnableUnfinishedTimeRegistrationDaysInOverview');
      this.enableCustomOvertimeSchedule = bool('EnableCustomOvertimeSchedule');
      this.requireGpsClockIn = bool('RequireGpsClockIn');
      this.enableCommentsOnTimesheetEntries = bool('EnableCommentsOnTimesheetEntries');
      this.autoClockOutTime = val('AutoClockOutTime') || '17:00';
      this.adjustedClockInTime = val('AdjustedClockInTime') || '08:00';
      const salaryDay = Number(val('SalaryPeriodStartDay'));
      this.salaryPeriodStartDay = Number.isFinite(salaryDay) && salaryDay >= 1 && salaryDay <= 31 ? Math.floor(salaryDay) : 1;
      this.enableBreakButton = bool('EnableBreakButton');
      this.enableTimesheetReminders = bool('EnableTimesheetReminders');
      this.timesheetReminderTime = val('TimesheetReminderTime') || '18:00';
      this.timeRegistrationDefaultAppScreen = bool('TimeRegistrationDefaultAppScreen');
      this.enableTimeRegistrationSyncToERP = bool('EnableTimeRegistrationSyncToERP');
      this.enableAbsenceView = bool('EnableAbsenceView');
      this.enableAbsenceSyncToERP = bool('EnableAbsenceSyncToERP');
      this.enableAutomaticERPSyncForTimeRegistrationEntries = bool('EnableAutomaticERPSyncForTimeRegistrationEntries');
      const deductMinutes = Number(val('AutoDeductBreakMinutes'));
      this.autoDeductBreakMinutes = Number.isFinite(deductMinutes) && deductMinutes > 0 ? Math.floor(deductMinutes) : 0;
      const deductThreshold = Number(val('AutoDeductBreakThresholdHours'));
      this.autoDeductBreakThresholdHours = Number.isFinite(deductThreshold) && deductThreshold >= 0 ? Math.floor(deductThreshold) : 5;

      // Custom name settings
      this.dayProjectAssignmentsCustomName = val('DayProjectAssignmentsCustomName');
      this.preCreatedDayProjectAssignmentsCustomName = val('PreCreatedDayProjectAssignmentsCustomName');

      // ERP settings
      this.timonUsername = val('TimonUsername');
      this.timonPassword = val('TimonPassword'); this.originalTimonPassword = this.timonPassword;
      this.timonUrl = val('TimonUrl');
      this.DKApiKey = val('DKApiKey'); this.OriginalDKApiKey = this.DKApiKey;
      this.DKWebhookSecret = val('DKWebhookSecret'); this.OriginalDKWebhookSecret = this.DKWebhookSecret;
      this.DKItemCode = rawVal('DKItemCode');
      for (const t of this.dkTimeRegAbsenceTypes) {
        const parts = rawVal(`DKTimeReg${t}Mapping`).split(';');
        this.dkTimeRegMappings[t].projectKey = (parts[0] || '').trim();
        this.dkTimeRegMappings[t].phaseKey = (parts[1] || '').trim();
      }
      this.initDkTimeRegMappings();
      this.DKTimeRegAfterHoursTarget = val('DKTimeRegAfterHoursTarget') || 'OverTime';
      this.DKTimeRegRedDayHoursTarget = val('DKTimeRegRedDayHoursTarget') || 'OverTime';
      this.DKTimeRegWorkEntriesBillable = rawVal('DKTimeRegWorkEntriesBillable') !== 'false';
      this.stolpiUsername = val('StolpiUsername');
      this.stolpiPassword = val('StolpiPassword'); this.originalStolpiPassword = this.stolpiPassword;
      this.BCTenantId = val('BusinessCentralCustomersTenantId');
      this.BCClientId = val('BusinessCentralCustomersClientId'); this.OriginalBCClientId = this.BCClientId;
      this.BCClientSecret = val('BusinessCentralCustomersClientSecret'); this.OriginalBCClientSecret = this.BCClientSecret;
      this.BCScope = val('BusinessCentralCustomersClientScope');
      this.BCTokenUrl = val('BusinessCentralCustomersTokenUrl');
      this.BCCompanyId = val('BusinessCentralCustomersCompanyId');
      this.BCLocationId = val('BusinessCentralCustomersLocationId');
      this.BCEnvironment = val('BusinessCentralCustomersEnvironment');
      // rawVal: item numbers like "100" must stay strings
      try { this.bcTimeRegItems = JSON.parse(rawVal('BusinessCentralTimeRegItems') || '[]'); } catch (e) { this.bcTimeRegItems = []; } // eslint-disable-line no-unused-vars
      this.bcSelectedItemNumbers = this.bcTimeRegItems.map(i => i.number);
      this.BCTimeRegDefaultItem = rawVal('BusinessCentralTimeRegDefaultItem');
      this.BCTimeRegOvertimeItem = rawVal('BusinessCentralTimeRegOvertimeItem');
      this.BCTimeRegAfterHoursTarget = val('BusinessCentralTimeRegAfterHoursTarget') || 'OverTime';
      this.BCTimeRegRedDayHoursTarget = val('BusinessCentralTimeRegRedDayHoursTarget') || 'OverTime';
      this.BCCostItem = rawVal('BusinessCentralCostItem');
      this.reglaUsername = val('ReglaUsername');
      this.reglaPassword = val('ReglaPassword'); this.originalReglaPassword = this.reglaPassword;
      this.verklagClientId = val('VerklagClientId');
      this.verklagClientSecret = val('VerklagClientSecret'); this.originalVerklagClientSecret = this.verklagClientSecret;
      this.unnurClientId = val('UnnurClientId');
      this.unnurClientSecret = val('UnnurClientSecret'); this.originalUnnurClientSecret = this.unnurClientSecret;
      this.unnurUrl = val('UnnurUrl');

      // Project data publisher credentials
      this.husasmidjanUsername = val('HusasmidjanUsername');
      this.husasmidjanPassword = val('HusasmidjanPassword'); this.originalHusasmidjanPassword = this.husasmidjanPassword;
    }
  },
};
</script>

<style>
.cs-tooltip.el-popper {
  max-width: min(360px, calc(100vw - 24px));
  white-space: normal;
  word-break: break-word;
  line-height: 1.4;
  z-index: 10000 !important;
}

.image-upload-page .el-select { width: 100%; margin-bottom: 30px; }
.image-containercustomersettings { display: flex; justify-content: space-between; }
.image-containercustomersettings > img, .image-containercustomersettings > image-upload { width: 49%; }

.ts-multi-pills {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  padding: 6px;
  background: rgba(200, 200, 200, 0.2);
  border-radius: 0.5rem;
}
.ts-multi-pills__item {
  display: inline-flex;
  align-items: center;
  padding: 6px 12px;
  border: 1px solid transparent;
  background: transparent;
  border-radius: 0.375rem;
  cursor: pointer;
  font-size: 0.875rem;
  font-weight: 500;
  color: #344767;
  white-space: nowrap;
  transition: background-color 0.2s ease, color 0.2s ease, border-color 0.2s ease;
  line-height: 1.5;
}
.ts-multi-pills__item:hover {
  background: rgba(0, 0, 0, 0.05);
  color: #344767;
}
.ts-multi-pills__item--active {
  background: #d9dfed;
  color: #344767;
}
.ts-multi-pills__icon {
  font-size: 1rem;
  vertical-align: middle;
}
.ts-multi-pills__toggle-all {
  display: inline-flex;
  align-items: center;
  padding: 4px 10px;
  border: 1px solid rgba(0, 0, 0, 0.15);
  background: transparent;
  border-radius: 0.375rem;
  cursor: pointer;
  font-size: 0.8125rem;
  font-weight: 500;
  color: #344767;
  transition: background-color 0.2s ease;
}
.ts-multi-pills__toggle-all:hover {
  background: rgba(0, 0, 0, 0.05);
}
.ts-multi-pills__toggle-all .material-icons {
  font-size: 1rem;
}
.ts-multi-pills__section .form-check {
  display: flex !important;
  flex-direction: row !important;
  flex-wrap: nowrap !important;
  align-items: center !important;
  width: 100% !important;
  padding: 0 !important;
  margin: 0 0 0.5rem 0 !important;
  min-height: 1.5em;
}
.ts-multi-pills__section .form-check > input.form-check-input {
  float: none !important;
  flex: 0 0 auto !important;
  margin: 0 0.5em 0 0 !important;
  align-self: center !important;
}
.ts-multi-pills__section .form-check > label.custom-control-label,
.ts-multi-pills__section .form-check > label.form-check-label {
  flex: 1 1 auto !important;
  min-width: 0 !important;
  display: block !important;
  margin: 0 !important;
  word-break: break-word !important;
  line-height: 1.5 !important;
}
.ts-multi-pills__grid {
  column-width: 320px;
  column-gap: 1.5rem;
  margin-top: 0.5rem;
}
.ts-multi-pills__section {
  display: inline-block;
  width: 100%;
  padding: 0.75rem 1rem;
  margin-bottom: 1rem;
  border: 1px solid rgba(0, 0, 0, 0.08);
  border-radius: 0.5rem;
  background: rgba(0, 0, 0, 0.015);
  break-inside: avoid;
  page-break-inside: avoid;
}
.ts-multi-pills__heading {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  margin-bottom: 0.5rem;
  font-size: 0.875rem;
  font-weight: 600;
  color: #344767;
  text-transform: uppercase;
  letter-spacing: 0.04em;
}
.ts-multi-pills__heading .material-icons {
  font-size: 1.1rem;
}

body.dark-version .ts-multi-pills {
  background: rgba(255, 255, 255, 0.08);
}
body.dark-version .ts-multi-pills__item {
  color: rgba(255, 255, 255, 0.85);
}
body.dark-version .ts-multi-pills__item:hover {
  background: rgba(255, 255, 255, 0.08);
  color: #fff;
}
body.dark-version .ts-multi-pills__item--active {
  background: linear-gradient(195deg, #FFCD3A, #E0B020);
  color: #191919;
}
body.dark-version .ts-multi-pills__toggle-all {
  border-color: rgba(255, 255, 255, 0.2);
  color: rgba(255, 255, 255, 0.85);
}
body.dark-version .ts-multi-pills__toggle-all:hover {
  background: rgba(255, 255, 255, 0.08);
}
body.dark-version .ts-multi-pills__heading {
  color: #fff;
}
body.dark-version .ts-multi-pills__section {
  border-color: rgba(255, 255, 255, 0.1);
  background: rgba(255, 255, 255, 0.03);
}
.cs-report-row {
  display: flex;
  align-items: center;
  gap: 6px;
}
.cs-info-icon {
  font-size: 18px;
  color: #8392ab;
  cursor: pointer;
  user-select: none;
}
.cs-info-icon:hover,
.cs-info-icon:focus {
  color: #5e72e4;
  outline: none;
}
</style>
